<template>
    <div class="container mt-10">
              <div
                :class="['p-2', 'cursor-pointer', escort_data.account_type === 'escort' ? 'bg-slide' : 'bg-slide1']"
                :style="{ backgroundImage: `url(${currentImage})` }"
                @click="openPreview(currentImage)"
              >
              <div v-if="logoutSplash" class="logout-splash">
                <span>{{ logoutMessage }}</span>
              </div>
              <p>&nbsp;</p>
              <div class="profile-container mt-10">
                  <div class="profile-image">
                      <!-- If no profile picture -->
                      <span v-if="escort_data.profilepic == null" class="select-profile">
                        <img
                          src="../assets/no_image.png"
                          class="large-profile-pic"
                          alt=""
                          width="140"
                          height="140"
                          style="border-radius: 50%;"
                        />
                      </span>

                      <!-- If profile picture exists -->
                      <span v-else class="select-profile position-relative">
                        <div
                          class="story-wrapper"
                          @click.stop="openStory()"
                          style="cursor: pointer; display: inline-block; position: relative;"
                        >
                          <img
                            :src="escort_data.profilepic"
                            class="large-profile-pic"
                            alt=""
                            width="140"
                            height="140"
                            :style="escortHasStory ? 'border: 3px solid #25D366; border-radius: 50%;' : 'border-radius: 50%;'"
                          />

                          <!-- Optional green ring -->
                          <div
                            v-if="escortHasStory"
                            class="story-ring"
                            style="position: absolute; top: -4px; left: -4px; width: 148px; height: 148px; border: 3px solid #25D366; border-radius: 50%;"
                          ></div>
                        </div>

                        <!-- Followers Count -->
                        <div class="likes-followers mt-1">
                          <h4 class="badge" style="color: #FFF; background: #1a1a2e;">{{ countFollowers }} followers</h4>
                          <div class="profile-metrics mt-1">
                            <div class="metric-card metric-card--views">
                              <span class="metric-label">Views: </span>
                              <span class="metric-value">{{ profileCount }}</span>
                             
                            </div>

                            <div class="metric-card metric-card--earn">
                              <span class="metric-label">Earned: </span>
                              <span class="metric-value">{{ formatToken(walletBalance) }}{{ token_label }}</span>
                            </div>
                          </div>
                        </div>
                        
                      </span>

                      <div class="profile-info">
                          <h3 class="model-name" style="color: #D33E74;">{{ toSentenceCase(escort_data.user_name) }}, {{ escort_data.age }}
                              <span v-if="escort_data.activation_paid == 1 && escort_data.account_type ==='escort'" class="verified-icon" title="Verified">
                                  <i class="fa fa-check-circle text-primary"></i>
                              </span>
                              <span v-if="escort_data.activation_paid == 1 && escort_data.account_type ==='content-creator'" class="verified-icon" title="Verified">
                                  <i class="fa fa-check-circle text-success"></i>
                              </span>
                          </h3>
                          <p style="color: #D33E74;">{{ toSentenceCase(escort_data.location) }} {{ toSentenceCase(escort_data.state) }} | {{ toSentenceCase(escort_data.gender) }} 
                            <span v-if="escort_data.account_type === 'escort'">
                              <button
                               :disabled="escort_data.activation_paid == 0"
                              :class="{ 'disabled': escort_data.activation_paid == 0 }"
                              @click.stop="openContactModal(escort_data.phone_number, escort_data.user_name )" 
                              style="cursor: pointer"                          
                              >
                                | <span v-if="$store.getters.canViewPhone">
                                    <i class="fa fa-phone"></i> {{ escort_data.phone_number }}
                                  </span>
                                  <span v-else>
                                    <i class="fa fa-phone"></i> *********
                                  </span>
                                </button>
                            </span>
                          </p>
                          
                          <p class="bio-text" style="color: #D33E74;">{{ toSentenceCase(escort_data.bio) }} </p>
                             <button
                              class="btn-tip"
                              type="button"
                              style="width: 90px;color: #FFFFFF; background-color: #6a11cb; font-size: 12px; border-radius: 50px; padding: 0.2rem;"
                              :disabled="escort_data.activation_paid == 0"
                              :class="{ 'disabled': escort_data.activation_paid == 0 }"
                              @click.stop="tipModel(escort_data.user_name)"
                            >
                              <i class="fa fa-gift me-2"></i>
                              Send Tip
                            </button>

                      </div>

                      <!-- After the cover and profile picture -->
                      <div class="profile-header-info text-center mt-4">
                        <div class="d-flex align-items-center justify-content-center gap-2 mb-2 mt-6">
                          <h3 class="mb-0 fw-bold text-white">{{ toSentenceCase(escort_data.user_name) }}, {{ escort_data.age }}</h3>
                          <i class="fa fa-check-circle text-primary fs-4"></i>
                        </div>

                        <p class="profile-meta mb-0 text-light">
                          {{ toSentenceCase(escort_data.gender) }}  
                          <span class="mx-2 opacity-75">•</span> 
                          {{ toSentenceCase(escort_data.location) }}, {{ toSentenceCase(escort_data.state) }}
                          
                        </p>

                        <button
                              class="btn-tip"
                              type="button"
                              style="width: 90px;color: #FFFFFF; background-color: #6a11cb; font-size: 12px; border-radius: 50px; padding: 0.2rem;"
                              :disabled="escort_data.activation_paid == 0"
                              :class="{ 'disabled': escort_data.activation_paid == 0 }"
                              @click.stop="tipModel(escort_data.user_name)"
                            >
                              <i class="fa fa-gift me-2"></i>
                              Send Tip
                        </button>
                        
                      </div>
                  </div>

                  <div class="profile-edit-button flex-nowrap overflow-x">
                    <div class="action-buttons">

                      <button
                          v-if="escort_data.account_type == 'escort'"
                          class="btn-book"
                          type="button"
                          style="width: 70px;color: #FFFFFF; background-color: #ff8a00; font-size: 12px; border-radius: 50px; padding: 0.2rem;"
                          @click.stop="openBookingModal()"
                        >
                          <i class="fa fa-calendar-check me-2"></i>Book
                      </button>
                      
                      <button
                        class="btn-follow"
                        type="button"
                        :disabled="escort_data.activation_paid == 0"
                        :class="{ 'disabled': escort_data.activation_paid == 0 }"
                        @click.stop="handleFollow"
                      >
                        <i class="fa fa-heart me-2"></i>
                        Follow
                      </button>

                    </div>
                  </div>
              </div>
            </div>
           
            <div class="bio-tab mt-10">
                <!-- Nav Tabs -->
                <ul class="nav nav-tabs profile-tabs mb-3 flex-nowrap overflow-auto" role="tablist" style="white-space: nowrap;">
                    <li class="nav-item" v-for="(tab, index) in tabs" :key="index">
                        <a
                            class="nav-link"
                            :class="{ active: activeTab === tab.name }"
                            @click="activeTab = tab.name"
                            href="#"
                        >
                          <span v-if="tab.name === 'contents'">
                            {{ tab.label }} <span class="badge badge-secondary">{{  paidVideoCount }}</span>
                          </span>
                          <span v-else-if="tab.name === 'photos'">
                            {{ tab.label }} <span class="badge badge-secondary">{{  paidImgCount }} </span>
                          </span>
                          <span v-else>
                            {{ tab.label }}
                          </span>
                        </a>
                    </li>
                </ul>

                <!-- Tab Content -->
                <div class="tab-content profile-tab-content p-1 border-0 rounded">
                    <div v-if="activeTab === 'contents'">
                          <div class="photo-container">
                            <div class="col-sm-12">
                              <div class="row">
                                <span v-if="escort_paid_videos.galleries.length === 0 && !active_subscriptions">
                                  <div class="locked-div" style="border: 1px dashed #ccc; padding: 20px; text-align: center; position: relative;">
                                    <i class="fa fa-lock" style="font-size: 24px; color: #555;"></i>
                                    <p style="margin-top: 10px; color: #777;">No content available!</p>
                                  </div>
                                </span>
                                <ModelPaidVideoGrid :videos="paid_videos || []" />
                            </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="activeTab === 'photos'">
                      <div class="photo-container">
                          <div class="col-sm-12">
                              <div class="row">
                                <span v-if="escort_paid_pictures.galleries.length === 0 && !active_subscriptions">
                                  <div class="locked-div" style="border: 1px dashed #ccc; padding: 20px; text-align: center; position: relative;">
                                    <i class="fa fa-lock" style="font-size: 24px; color: #555;"></i>
                                    <p style="margin-top: 10px; color: #777;">No content available!</p>
                                  </div>
                                </span>
                              
                                <!-- <h5 v-if="paid_profiles.length > 0" class="text-white">{{  toSentenceCase(escort_data.user_name) }} photos</h5> -->
                                <ModelPaidPictureGrid :profiles="paid_profiles || []" />
                              
                              </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="activeTab === 'about'" class="tab-panel-shell">
                      <div class="tab-panel-header">
                        <div>
                          <p class="panel-eyebrow">Profile overview</p>
                          <h5 class="panel-title">About {{ escort_data.user_name }}</h5>
                        </div>
                      </div>
                          
                          <div class="photo-container tab-panel-card">
                            <div class="col-sm-12 profile-count-container">
                             
                            </div>
                            <div class="col-sm-12 text-white">
                              <div class="bio-container mt-2" v-if="escort_data.account_type === 'escort'">
                              <div class="profile-preference" v-if="preferences.build">
                              <h6>Build Size</h6>
                              <small>{{ preferences.build }}</small>
                              </div>
                              <div class="profile-preference" v-if="preferences.bustSize">
                              <h6>Bust Size</h6>
                              <small>{{ preferences.bustSize }}</small>
                              </div>
                              <div class="profile-preference" v-if="preferences.ethnicity">
                              <h6>Ethnicity</h6>
                              <small>{{ preferences.ethnicity }}</small>
                              </div>
                            </div>
                            <p class="bio-content-text mt-4">{{ escort_data.bio }}</p> 
                            <div class="rate-display-section" v-if="escort_data.account_type === 'escort'">
                              <h5 v-if="rates.length > 0"><strong class="text-white"><i class="fas fa-receipt"></i> In-Call Out-Call Rate</strong></h5>
                            
                                <div v-if="rates.length > 0" class="rate-list">
                                    <div class="rate-card" v-for="(rate, index) in rates" :key="index">
                                        <i class="fa fa-tag"></i>
                                    <div class="rate-duration">{{ rate.duration }}</div>
                                    <div class="rate-price">
                                        <strong>In Call:</strong> {{ formatPrice(rate.in_call_price) }}
                                    </div>
                                    <div class="rate-price">
                                        <strong>Out Call:</strong> {{ formatPrice(rate.out_call_price) }}
                                    </div>
                                    </div>
                                </div>

                                <div v-else class="no-rates">
                                    <p>No rates available at the moment.</p>
                                </div>
                                <!-- <button
                                  class="btn btn-primary mt-3"
                                >
                                  Book Now
                                </button> -->
                            </div>

                            <div class="preferences-list" v-if="escort_data.account_type === 'escort'">
                              <h5 v-if="preferences.transport_fare"><strong class="text-white"><i class="fas fa-receipt"></i> Preferences</strong></h5>
                                <div v-if="preferences" class="row">
                                  <div class="col-md-3 mb-3" v-if="preferences.transport_fare">
                                    <div class="preference-item">
                                      <strong>Transport:</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.transport_fare }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.personality">
                                    <div class="preference-item">
                                      <strong>Personality:</strong>
                                      <span v-for="(item, index) in preferences.personality.split(',')" :key="'personality-' + index" class="d-block mb-1">
                                        <i class="fa fa-check-circle text-success me-1"></i>{{ item.trim() }}
                                      </span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.gender_type">
                                    <div class="preference-item">
                                      <strong>Gender Type:</strong>
                                      <span  class="d-block mb-1">
                                        <i class="fa fa-check-circle text-success me-1"></i>{{ preferences.gender_type }}
                                      </span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.interests">
                                    <div class="preference-item">
                                      <strong>Likes & Interests:</strong>
                                      <span v-for="(item, index) in preferences.interests.split(',')" :key="'interest-' + index" class="d-block mb-1">
                                        <i class="fa fa-check-circle text-success me-1"></i>{{ item.trim() }}
                                      </span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.turn_ons">
                                    <div class="preference-item">
                                      <strong>Turn Ons:</strong>
                                      <span v-for="(item, index) in preferences.turn_ons.split(',')" :key="'turnon-' + index" class="d-block mb-1">
                                        <i class="fa fa-check-circle text-success me-1"></i>{{ item.trim() }}
                                      </span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.turn_offs">
                                    <div class="preference-item">
                                      <strong>Turn Offs:</strong>
                                      <span v-for="(item, index) in preferences.turn_offs.split(',')" :key="'turnoff-' + index" class="d-block mb-1">
                                        <i class="fa fa-check-circle text-success me-1"></i>{{ item.trim() }}
                                      </span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.smokes">
                                    <div class="preference-item">
                                      <strong>Smokes?</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.smokes }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.drinks">
                                    <div class="preference-item">
                                      <strong>Drinks?</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.drinks }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.tattoos_or_piercings">
                                    <div class="preference-item">
                                      <strong>Tattoos or Piercings?</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.tattoos_or_piercings }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.group_booking">
                                    <div class="preference-item">
                                      <strong>Accept Group Bookings?</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.group_booking }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.video_chat_available">
                                    <div class="preference-item">
                                      <strong>Open to Video Chat?</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.video_chat_available }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.build">
                                    <div class="preference-item">
                                      <strong>Body Build</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.build }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.bustSize">
                                    <div class="preference-item">
                                      <strong>Bust Size</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.bustSize }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.ethnicity">
                                    <div class="preference-item">
                                      <strong>Ethnicity</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.ethnicity }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.education">
                                    <div class="preference-item">
                                      <strong>Education</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.education }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.occupation">
                                    <div class="preference-item">
                                      <strong>Occupation</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.occupation }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.weight">
                                    <div class="preference-item">
                                      <strong>Weight</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.weight }}</span>
                                    </div>
                                  </div>

                                  <div class="col-md-3 mb-3" v-if="preferences.height">
                                    <div class="preference-item">
                                      <strong>Height</strong>
                                      <span><i class="fa fa-check-circle text-success me-1"></i>{{ preferences.height }}</span>
                                    </div>
                                  </div>
                                
                                </div>
                                <div v-if="preferences.services">
                                  <!-- Separate row for Services -->
                                  <div class="row">
                                    <div class="col-12 preference-item">
                                      <strong>Services:</strong>
                                    </div>
                                  </div>
                                </div>
                                <div v-if="preferences.services">
                                  <!-- Separate row for Services -->
                                  <div class="row">
                                    <div class="col-12 preference-item-p" v-if="preferences.services">
                                      <div>
                                        <div class="row">
                                          <div class="col-md-3 mb-2" v-for="(item, index) in preferences.services.split(',')" :key="'service-' + index">
                                            <i class="fa fa-check-circle text-success me-1"></i>{{ item.trim() }}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="activeTab === 'truthdare'" class="tab-panel-shell truth-panel">
                      <h5 class="mb-0 text-white me-3">
                        <i class="fa fa-question-circle"></i> Truth & Dare
                      </h5>

                      <p class="text-white mt-3 p-2">
                        Break the ice and make things exciting with a classic game of <strong>Truth & Dare</strong>.  
                        You get to challenge <strong>{{ escort_data.user_name }}</strong> to answer a bold question (Truth)  
                        or take on a fun/crazy task (Dare). It’s the perfect way to add some spice, laughter, and surprises  
                        while keeping the moment entertaining.
                      </p>

                      <p class="text-white mt-2 p-2">
                        Be creative but respectful — the goal is to make it playful and enjoyable for both sides.  
                        Ready to push the limits and see how daring <strong>{{ escort_data.user_name }}</strong> can be? 😉
                      </p>

                      <button 
                        class="btn btn-sm btn-primary p-2 mt-3 request-cta"
                        @click="openTruthDareModal()" 
                      >
                        <i class="fa fa-paper-plane"></i> Send truth or dare request to {{ escort_data.user_name }}
                      </button>
                    </div>

                    <div v-if="activeTab === 'review'" class="tab-panel-shell review-panel">

                      <h5 class="mb-3 text-white"> Review</h5>

                      <!-- Review List -->
                      <div class="row g-3">
                        <div 
                          class="col-12 col-md-6" 
                          v-for="(item, index) in reviews" 
                          :key="index"
                        >
                          <div class="card shadow-sm h-100 review-card">
                            <div class="card-body">
                              <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="card-title mb-0">{{ item.reviewer }}</h6>
                                <small class="text-muted">{{ new Date(item.created_at).toLocaleDateString('en-US', { year:'numeric', month:'short', day:'numeric' }) }}</small>
                              </div>

                              <!-- Stars -->
                              <div class="mb-2">
                                <span v-for="n in 5" :key="n">
                                  <i class="fa" :class="n <= item.rating ? 'fa-star text-warning' : 'fa-star-o text-secondary'"></i>
                                </span>
                              </div>

                              <!-- Review Text -->
                              <p class="card-text" style="white-space: pre-wrap;">{{ item.review }}</p>
                            </div>
                          </div>
                        </div>

                        <!-- No Reviews -->
                        <div v-if="reviews.length === 0" class="col-12">
                          <div class="empty-reviews">
                            <i class="fa fa-star-o"></i>
                            <p>No reviews yet.</p>
                          </div>
                        </div>
                      </div>

                      <form @submit.prevent="submitReview">
                        <!-- Rating -->
                        <div class="rating-container mb-0">
                          <label class="form-label text-white"></label>
                          <div class="d-flex gap-1">
                            <label 
                              v-for="n in 5" 
                              :key="n"
                              class="star-label"
                              :class="n <= rating ? 'text-warning' : 'text-secondary'"
                              style="cursor: pointer; font-size: 24px;"
                            >
                              <input 
                                type="radio" 
                                :value="n" 
                                v-model="rating" 
                                style="display: none;"
                              />
                              ★
                            </label>
                          </div>
                          <!-- <p class="text-white mt-1">Selected Rating: {{ rating }}</p> -->
                        </div>

                        <!-- Review Text -->
                        <div class="mb-3">
                          <label class="form-label text-white"></label>
                          <textarea
                            class="form-control review-input"
                            rows="4"
                            placeholder="Write your review..."
                            v-model="review"
                          ></textarea>
                        </div>

                        <!-- Submit Button -->
                        <button type="submit" class="btn btn-primary w-100 review-submit">
                          Submit Review
                        </button>

                      </form>

                    </div>
                </div>
            </div>

            <div v-if="splashScreen">
                <transition name="modal" >
                    <div class="modal-mask">
                        <div class="modal-wrapper col-md-4" style="margin:auto">
                            <!-- <div class="modal-dialog modal-xl"> -->
                                <div class="profile-view2">
                                    <hr style="color:#3E3D3D; margin-top:-20px">
                                    <span class="profile-bio2">
                                        <p style="font-size:x-large">
                                            <i class="fas fa-spinner"></i> Processing...
                                        </p>
                                    </span>
                                </div>
                            <!-- </div> -->
                        </div>
                    </div>
                </transition>
            </div> 

            <div v-if="picture_comment">
              <transition name="modal" >
                  <div class="modal-masky">
                      <div class="modal-wrapper col-md-4" style="margin:auto">
                          <!-- <div class="modal-dialog modal-xl"> -->
                              <div class="profile-view2" style="height: 50px !important">
                                  <div class="row">
                                      <div class="col-md-1">
                                        
                                      </div>
                                      <div class="col-md-10">
                                          <div class="row">
                                              <center style="color:#FFF; margin-top:4px">
                                                  Send message
                                              </center>
                                              <input type="text" v-model="user_message" placeholder="Say something nice!" class="form-control login-modal-box">
                                              <input type="hidden" v-model="user_id">
                                              <button class="btn-login" @click="sendMessage">
                                                  <span v-if="message_status">
                                                      <i  class="fas fa-spinner fa-spin"></i>
                                                  </span>
                                                  <span v-else>Send</span>
                                                  
                                              </button>
                                              <button style="color:#FFF; margin-top:4px" @click="picture_comment = false">
                                                  Cancel
                                              </button>
                                          </div>
                                      </div>
                                      <div class="col-md-1">
                                          <div>
                                              
                                          </div>
                                      </div>
                      
                                  </div>
                                  
                              </div>
                          <!-- </div> -->
                      </div>
                  </div>
              </transition>
            </div> 

          <!--Free Image Modal -->
          <div class="modal fade" id="freeImageModal" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg"> <!-- large modal -->
              <div class="modal-content bg-transparent border-0">
                <div class="modal-body p-0 position-relative">

                  <!-- Bootstrap Carousel -->
                  <div id="escortImageCarousel" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                      <div
                      v-for="(image, index) in escort_free_pictures.galleries"
                      :key="index"
                      :class="['carousel-item', { active: index === selectedFreeImageIndex }]"
                    >
                      <img
                        :src="image.path"
                        class="d-block w-100 img-fluid fullmobile-size"
                        style="object-fit: cover;"
                      />
                    </div>

                    </div>

                    <!-- Optional carousel controls -->
                    <button class="carousel-control-prev" type="button" data-bs-target="#escortImageCarousel" data-bs-slide="prev">
                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#escortImageCarousel" data-bs-slide="next">
                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>

                  <!-- Close button -->
                <button
                  @click="closeFreeModal"
                  type="button"
                  class="btn-close position-absolute top-0 end-0 m-3 text-white"
                  style="z-index: 1056;color:#fff !important"
                  aria-label="Close"
                ></button>
                </div>
              </div>
            </div>
          </div>

            <!--Image Modal -->
          <div class="modal fade" id="imageModal" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg"> <!-- large modal -->
              <div class="modal-content bg-transparent border-0">
                <div class="modal-body p-0 position-relative">

                  <!-- Bootstrap Carousel -->
                  <div id="escortImageCarousel" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                      <div
                      v-for="(image, index) in escort_paid_pictures.galleries"
                      :key="index"
                      :class="['carousel-item', { active: index === selectedImageIndex }]"
                    >
                      <img
                        :src="image.path"
                        :class="{ 'blurred': image.is_premium === 'paid' && !isImageUnlocked(image.id) }"
                        class="d-block w-100 img-fluid fullmobile-size"
                        style="object-fit: cover;"
                      />
                    </div>

                    </div>

                    <!-- Optional carousel controls -->
                    <button class="carousel-control-prev" type="button" data-bs-target="#escortImageCarousel" data-bs-slide="prev">
                      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#escortImageCarousel" data-bs-slide="next">
                      <span class="carousel-control-next-icon" aria-hidden="true"></span>
                      <span class="visually-hidden">Next</span>
                    </button>
                  </div>

                  <!-- Close button -->
                <button
                  @click="closeModal"
                  type="button"
                  class="btn-close position-absolute top-0 end-0 m-3 text-white"
                  style="z-index: 1056;color:#fff !important"
                  aria-label="Close"
                ></button>
                </div>
              </div>
            </div>
          </div>

          <!-- Video Modal -->
          <div class="modal fade" id="vidModal" tabindex="-1" aria-labelledby="vidModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm"> <!-- large modal -->
              <div class="modal-content bg-transparent border-0">
                <div class="modal-body p-0 position-relative">

                  <!-- Bootstrap Carousel -->
                  <div id="escortVideoCarousel" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                        <div
                        v-for="(video, index) in escort_video.videos"
                        :key="index"
                        :class="['carousel-item', { active: index === selectedVideoIndex }]"
                      >
                      <video
                        :src="video.file"
                        controls
                        controlsList="nodownload"
                        :class="{ 'blurred img-fluid': video.is_premium === 'paid' && !active_subscriptions }"
                        style="border-radius: 10px; cursor: pointer;"
                        @click="openVidModal(index)"
                      >
                        Your browser does not support the video tag.
                      </video>

                      </div>

                    </div>

                    <!-- Up Button -->
                  <button class="carousel-control-prev vertical-control" type="button" data-bs-target="#escortVideoCarousel" data-bs-slide="prev">
                    <span class="carousel-control-up-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>

                  <!-- Down Button -->
                  <button class="carousel-control-next vertical-control" type="button" data-bs-target="#escortVideoCarousel" data-bs-slide="next">
                    <span class="carousel-control-down-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>

                  </div>

                  <!-- Close button -->
                <button
                  @click="closeVidModal"
                  type="button"
                  class="btn-close position-absolute top-0 end-0 m-3 text-white"
                  style="z-index: 1056;color:#fff !important"
                  aria-label="Close"
                ></button>
                </div>
              </div>
            </div>
          </div>

         
          <div class="modal fade" id="storyModal" tabindex="-1" aria-labelledby="storyModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content bg-transparent border-0">
              <div class="modal-body p-0 position-relative">

                <!-- Bootstrap Carousel -->
                <div id="storyCarousel" class="carousel slide" data-bs-ride="carousel">
                  <div class="carousel-inner">
                    <div
                      v-for="(story, index) in stories"
                      :key="index"
                      :class="['carousel-item', { active: index === selectedStoryIndex }]"
                    >
                      <!-- Display image or video -->
                      <template v-if="story.media_type === 'image'">
                        <img :src="story.media_url" class="d-block w-100 img-fluid" style="object-fit: cover; height: 750px;" />
                      </template>
                      <template v-else>
                        <video :src="story.media_url" controls autoplay muted class="d-block w-100 img-fluid" style="object-fit: cover; height: 750px;"></video>
                      </template>
                    </div>
                  </div>

                  <!-- Carousel controls -->
                  <button class="carousel-control-prev" type="button" data-bs-target="#storyCarousel" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target="#storyCarousel" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>

                <!-- Close button -->
                <button
                  @click="closeModalx"
                  type="button"
                  class="btn-close position-absolute top-0 end-0 m-3 text-white"
                  style="z-index: 1056;color:#fff !important"
                  aria-label="Close"
                ></button>

              </div>
            </div>
          </div>
          </div>

           <!-- Subscription Modal -->
          <div v-if="showSubscriptionModal" class="modal-backdrop">
            <div class="modal-subs modal-dialog-centered modal-lg shadow-lg rounded" style="display:block;">
              <div class="modal-content">
                <!-- Header -->
                <div class="modal-header subs-content text-white">
                  <h5 class="modal-title">
                    <i class="bi bi-credit-card"></i> Subscription Plans
                  </h5>
                  <button type="button" class="btn-close btn-close-white" @click="closeSubscription"></button>
                </div>

                <!-- Body -->
                <div class="modal-body subs-content">
                  <div class="d-flex flex-column justify-content-center" v-if="media_price">
                    <div>
                    <p style="text-align: center; font-size: 16px">You can purchase this assets for: <button @click="purchaseAssets(media_price, asset_id)" class="btn btn-success" style="border: solid 0px; font-size: 12px; text-decoration: none;"><i class="fa fa-shopping-cart"></i> {{ formatPrice(media_price) }}</button> </p> 
                    </div>
                    <p v-if="services.length > 0" style="text-align: center; font-weight: bold; font-size: 34px;">OR</p>
                  </div>
                  <br>
                  <p class="text-muted" v-if="services.length > 0">Choose the subscription plan that works best for you</p>
                  <div v-if="services.length > 0" class="row">
                    <div
                      class="col-6 col-md-4 mb-4"
                      v-for="(service, index) in services"
                      :key="index"
                    >
                      <div class="card border-1 shadow-sm h-100">
                        <div class="card-body d-flex flex-column">
                          <!-- Tier Name -->
                          <h5 class="fw-bold mb-2 text-primary">{{ service.category }}</h5>

                          <!-- Price & Duration -->
                          <p class="mb-1"><strong>Price:</strong> {{ service.dayruns_token }}{{ token_label }}</p>
                          <p class="mb-1"><strong>Duration:</strong> {{ service.duration ? service.duration + ' days' : 'N/A' }}</p>

                          <!-- Subscribe Button -->
                          <div class="mt-auto">
                            <button
                              class="btn btn-primary w-100"
                              :disabled="service.enabled !== 'true'"
                              @click="bookService(service)"
                            >
                              Subscribe
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- No Plans -->
                  <div v-else class="text-center text-muted py-5">
                    <i class="bi bi-emoji-frown fs-1"></i>
                    <p class="mt-3">No subscription plans available at the moment</p>
                  </div>
                </div>

                <!-- Footer -->
                <div class="modal-footer subs-content">
                  <button type="button" class="btn btn-outline-secondary" @click="closeSubscription">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Truth & Dare Request Modal -->
          <div v-if="showTruthDareModal" class="modal fade show d-block" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-lg">
              <div class="modal-content shadow-lg border-0 rounded-3">

                <!-- Modal Header -->
                <div class="modal-header  text-white" style="background: linear-gradient(90deg, #6a11cb, #2575fc);">
                  <h5 class="modal-title fw-bold">
                    <i class="fa fa-question-circle me-2"></i> Truth & Dare Request
                  </h5>
                  <button type="button" class="btn-close btn-close-white" @click="closeTruthDareModal"></button>
                </div>

                <!-- Modal Body -->
                <div class="modal-body bg-light">
                  <form @submit.prevent="submitTruthDareRequest">

                    <!-- Request Type -->
                    <div class="mb-4">
                      <label class="form-label fw-semibold">Request Type</label>
                      <select v-model="request_type" class="form-select" required>
                        <option disabled value="">Choose...</option>
                        <option value="truth">🗣️ Truth</option>
                        <option value="dare">🔥 Dare</option>
                      </select>
                    </div>

                    <!-- Request Details -->
                    <div class="mb-4">
                      <label class="form-label fw-semibold">Details</label>
                      <textarea v-model="request_details" 
                        class="form-control" rows="3" 
                        :placeholder="`Describe what you would like ${escort_data.user_name} to do.`"
                        required></textarea>
                    </div>

                    <!-- Reward & Currency -->
                    <div class="row g-3 mb-4">
                      <div class="col-md-6">
                        <label class="form-label fw-semibold">Reward Token</label>
                        <div class="input-group">
                          <span class="input-group-text"><i class="fa fa-gift"></i></span>
                          <input type="number" step="0.01" v-model="reward_token" 
                                class="form-control" placeholder="Enter number of token. e.g 20" required />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <label class="form-label fw-semibold">Deadline</label>
                        <input type="datetime-local" v-model="deadline" class="form-control" />
                      </div>
                    </div>
                  </form>
                </div>

                <!-- Modal Footer -->
                <div class="modal-footer bg-white">
                  <button type="button" class="btn btn-outline-secondary" @click="closeTruthDareModal">
                    <i class="fa fa-times"></i> Cancel
                  </button>
                  <button type="button" class="btn btn-primary" @click="submitTruthDareRequest">
                    <span v-if="truthdare_status">
                        <i  class="fas fa-spinner fa-spin"></i>
                    </span>
                    <span v-else><i class="fa fa-paper-plane"></i> Send Request</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Backdrop -->
          <div v-if="showTruthDareModal" class="modal-backdrop fade show"></div>

          <!-- Contact Options Modal -->
          <div 
          class="modal fade" 
          id="contactModal" 
          tabindex="-1" 
          aria-labelledby="contactModalLabel" 
          aria-hidden="true"
          >
          <div class="modal-dialog modal-dialog-centered modal-md contact-modal-dialog">
              <div class="modal-content contact-modal-card">
                <div class="contact-modal-header">
                  <div class="contact-modal-title-wrap">
                    <span class="contact-eyebrow">Contact options</span>
                    <h5 class="modal-title contact-modal-title" id="contactModalLabel">
                      Reach out to <span class="contact-name">{{ selectedModel }}</span>
                    </h5>
                    <p class="contact-modal-subtitle mb-0">
                      Choose how you'd like to connect. The number stays private until you act.
                    </p>
                  </div>
                  <button type="button" class="btn-close btn-close-white contact-close-btn" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="contact-modal-body">
                  <div class="contact-summary-card">
                    <div class="contact-icon-pill">
                      <i class="fa fa-shield-alt"></i>
                    </div>
                    <div>
                      <p class="contact-summary-label mb-1">Direct contact</p>
                      <p class="contact-summary-value mb-0">{{ selectedNumber }}</p>
                    </div>
                  </div>

                  <div class="contact-actions">
                    <button type="button" class="btn contact-action-btn contact-action-btn--call" @click="dialNumber(selectedNumber)">
                      <i class="fa fa-phone"></i>
                      <span>
                        <strong>Call now</strong>
                        <small>Open your phone dialer</small>
                      </span>
                    </button>

                    <button type="button" class="btn contact-action-btn contact-action-btn--whatsapp" @click="whatsappNumber(selectedNumber)">
                      <i class="fab fa-whatsapp"></i>
                      <span>
                        <strong>WhatsApp</strong>
                        <small>Start a secure chat</small>
                      </span>
                    </button>
                  </div>

                  <p class="contact-modal-footnote mb-0">
                    Tip: verify the number before placing a call, especially on mobile.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal Preview -->
         <div v-if="showPreview" class="modal-overlay" @click.self="closePreview">
          <div class="modal-content-bg">
            
            <!-- IMAGE PREVIEW -->
            <img
              v-if="isImage(escort_free_pictures.galleries[previewIndex].path)"
              :src="escort_free_pictures.galleries[previewIndex].path"
              class="preview-img"
            />

            <!-- VIDEO PREVIEW -->
            <video
              v-else-if="isVideo(escort_free_pictures.galleries[previewIndex].path)"
              :src="escort_free_pictures.galleries[previewIndex].path"
              controls
              autoplay
              class="preview-video"
            >
              Your browser does not support the video tag.
            </video>

            <button class="close-btn" @click="closePreview">✕</button>

            <!-- Navigation buttons -->
            <button class="nav-btn prev-btn" @click.stop="prevImage">‹</button>
            <button class="nav-btn next-btn" @click.stop="nextImage">›</button>
          </div>
         </div>

          <page-loader :is-loading="isLoading"></page-loader>

          <!-- Booking Choice Modal -->
          <div class="modal fade" id="bookingChoiceModal" tabindex="-1" aria-labelledby="bookingChoiceModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-md">
              <div class="modal-content booking-choice-card">
                <div class="booking-modal-header">
                  <div class="booking-modal-title-wrap">
                    <span class="booking-eyebrow">Private Request</span>
                    <h5 class="modal-title booking-modal-title" id="bookingChoiceModalLabel">How would you like to proceed?</h5>
                    <p class="booking-modal-subtitle mb-0">
                      Choose one option below to continue with {{ toSentenceCase(escort_data.user_name) }}.
                    </p>
                  </div>

                  <button type="button" class="btn-close btn-close-white booking-close-btn" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="booking-modal-body">
                  <div class="booking-choice-grid">
                    <button type="button" class="btn booking-choice-btn" @click="selectBookingOption('interest')">
                      <i class="fa fa-star"></i>
                      <span>
                        <strong>Show Interest</strong>
                        <small>Fill a quick form to express interest.</small>
                      </span>
                    </button>

                    <button type="button" class="btn booking-choice-btn" @click="selectBookingOption('booking')">
                      <i class="fa fa-calendar-check"></i>
                      <span>
                        <strong>Booking</strong>
                        <small>Continue with the normal booking process.</small>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Show Interest Modal -->
          <div class="modal fade" id="showInterestModal" tabindex="-1" aria-labelledby="showInterestModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-booking-dialog">
              <div class="modal-content booking-modal-card">
                <div class="booking-modal-header">
                  <div class="booking-modal-title-wrap">
                    <span class="booking-eyebrow">Show Interest</span>
                    <h5 class="modal-title booking-modal-title" id="showInterestModalLabel">Show interest in {{ toSentenceCase(escort_data.user_name) }}</h5>
                    <p class="booking-modal-subtitle mb-0">
                      Share your details so your request can be reviewed quickly.
                    </p>
                  </div>

                  <button type="button" class="btn-close btn-close-white booking-close-btn" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="booking-modal-body">
                  <div class="booking-panel">
                    <div class="booking-panel-header">
                      <h6 class="booking-panel-title">Client interest form</h6>
                      <p class="booking-panel-text">Complete the required details below.</p>
                    </div>

                    <div class="row g-3">
                      <div class="col-md-6">
                        <label for="interestName" class="form-label booking-label">Full name</label>
                        <input id="interestName" type="text" class="form-control booking-control" v-model.trim="interestForm.name" placeholder="Your full name" required>
                      </div>

                      <div class="col-md-6">
                        <label for="interestPhone" class="form-label booking-label">Phone number</label>
                        <input id="interestPhone" type="text" class="form-control booking-control" v-model.trim="interestForm.phone" placeholder="Phone number" required>
                      </div>

                      <div class="col-md-6">
                        <label for="interestDate" class="form-label booking-label">Preferred date</label>
                        <input id="interestDate" type="date" class="form-control booking-control" v-model="interestForm.date" required>
                      </div>

                      <div class="col-md-6">
                        <label for="interestTime" class="form-label booking-label">Preferred time</label>
                        <input id="interestTime" type="time" class="form-control booking-control" v-model="interestForm.time" required>
                      </div>

                      <div class="col-md-4">
                        <label for="interestDuration" class="form-label booking-label">Duration</label>
                        <input id="interestDuration" type="text" class="form-control booking-control" v-model.trim="interestForm.duration" placeholder="Enter duration" required>
                      </div>

                      <div class="col-md-4">
                        <label for="interestBudget" class="form-label booking-label">Budget (token)</label>
                        <input
                          id="interestBudget"
                          type="number"
                          min="1"
                          class="form-control booking-control"
                          v-model="interestForm.budget"
                          placeholder="Enter token budget"
                          required
                        >
                        <small class="text-warning d-block mt-1" v-if="interestForm.budget">
                          Naira equivalent: ₦{{ Number(interestForm.budget) * 10 }}
                        </small>
                      </div>

                      <div class="col-md-4">
                        <label for="interestLocation" class="form-label booking-label">Location</label>
                        <input id="interestLocation" type="text" class="form-control booking-control" v-model.trim="interestForm.location" placeholder="Meeting location" required>
                      </div>

                      <div class="col-12">
                        <label for="interestNote" class="form-label booking-label">Message</label>
                        <textarea
                          id="interestNote"
                          rows="4"
                          class="form-control booking-control booking-textarea"
                          v-model.trim="interestForm.message"
                          placeholder="Tell us your expectations or preferences..."
                          required
                        ></textarea>
                      </div>
                    </div>

                    <div class="booking-actions">
                      <button type="button" class="btn booking-btn booking-btn--ghost" data-bs-dismiss="modal">Cancel</button>
                      <button type="button" class="btn booking-btn booking-btn--primary" @click="submitShowInterest" :disabled="interest_loading">
                        <span v-if="interest_loading"><i class="fas fa-spinner fa-spin"></i> Sending...</span>
                        <span v-else>Submit Interest</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

           <!-- Booking Modal -->
          <div class="modal fade" id="bookingModal" tabindex="-1" aria-labelledby="bookingModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-booking-dialog">
              <div class="modal-content booking-modal-card">
                
                <div class="booking-modal-header">
                  <div class="booking-modal-title-wrap">
                    <span class="booking-eyebrow">Private Booking</span>
                    <h5 class="modal-title booking-modal-title" id="bookingModalLabel">Book {{ toSentenceCase(escort_data.user_name) }}</h5>
                    <p class="booking-modal-subtitle mb-0">
                      Choose your budget first, then share the details for a polished booking request.
                    </p>
                  </div>

                  <button type="button" class="btn-close btn-close-white booking-close-btn" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="booking-modal-body">
                  <div class="booking-summary-card">
                    <div class="booking-summary-chip">
                      <i class="fa fa-user me-2"></i>
                      {{ toSentenceCase(escort_data.user_name) }}
                    </div>
                    <div class="booking-summary-chip">
                      <i class="fa fa-map-marker-alt me-2"></i>
                      {{ toSentenceCase(escort_data.location) }}, {{ toSentenceCase(escort_data.state) }}
                    </div>
                    <div class="booking-summary-chip">
                      <i class="fa fa-coins me-2"></i>
                      {{ formatToken(walletBalance) }}{{ token_label }} available
                    </div>
                  </div>

                  <div class="booking-step-indicator">
                    <span :class="['booking-step', { active: isBookingAmount }]">1. Budget</span>
                    <span :class="['booking-step', { active: isBooking }]">2. Details</span>
                  </div>

                  <div v-if="isBookingAmount" class="booking-panel">
                    <div class="booking-panel-header">
                      <h6 class="booking-panel-title">Set your booking budget</h6>
                      <p class="booking-panel-text">
                        Tell us how much you want to allocate for this booking.
                      </p>
                    </div>

                    <div class="mb-3">
                      <label for="bookingAmount" class="form-label booking-label">Token</label>
                      <input
                        id="bookingAmount"
                        type="number"
                        min="1"
                        class="form-control booking-control"
                        v-model="booking_amount"
                        placeholder="Enter token here..."
                        required
                      >
                      <p class="booking-help-text">
                        Please enter the amount of token you want to book this escort with.
                      </p>
                    </div>

                    <div class="booking-actions booking-actions--single">
                      <button type="button" class="btn booking-btn booking-btn--primary" @click="check_booking_amount">
                        Continue
                      </button>
                    </div>
                  </div>

                  <div v-if="isBooking" class="booking-panel">
                    <div class="booking-panel-header">
                      <h6 class="booking-panel-title">Booking details</h6>
                      <p class="booking-panel-text">
                        Add the date, time, duration, and a short note to make the request clear.
                      </p>
                    </div>

                    <div class="row g-3">
                      <div class="col-md-6">
                        <label for="date" class="form-label booking-label">Date</label>
                        <input id="date" type="date" class="form-control booking-control" v-model="booking_date" required>
                      </div>

                      <div class="col-md-6">
                        <label for="time" class="form-label booking-label">Time</label>
                        <input id="time" type="time" class="form-control booking-control" v-model="booking_time" required>
                      </div>

                      <div class="col-md-6">
                        <label for="duration" class="form-label booking-label">Duration</label>
                        <select id="duration" class="form-select booking-control" v-model="booking_duration" required>
                          <option value="">Choose</option>
                          <option value="One Hour">One Hour</option>
                          <option value="Over Night">Over Night</option>
                          <option value="Weekend">Weekend</option>
                        </select>
                      </div>

                      <div class="col-md-6">
                        <label for="bookingPhone" class="form-label booking-label">Phone number</label>
                        <input id="bookingPhone" type="text" maxlength="10" class="form-control booking-control" v-model="booking_phone" required>
                      </div>

                      <div class="col-12">
                        <label for="message" class="form-label booking-label">Message</label>
                        <textarea
                          id="message"
                          rows="4"
                          class="form-control booking-control booking-textarea"
                          v-model="booking_message"
                          placeholder="Add any special instructions or preferences..."
                          required
                        ></textarea>
                        <p class="booking-help-text">
                          Please provide a valid phone number the escort can reach you on.
                        </p>
                      </div>
                    </div>

                    <div class="booking-actions">
                      <button type="button" class="btn booking-btn booking-btn--ghost" data-bs-dismiss="modal">Cancel</button>
                      <button type="submit" class="btn booking-btn booking-btn--primary" @click="submit_booking">Submit Booking</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Tip Modal -->
          <div class="modal fade" id="tipModal" tabindex="-1" aria-labelledby="tipModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content" style="background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%); border: 1px solid #ff8a00;">
                
                <!-- Modal Header -->
                <div class="modal-header border-0 pb-2" style="background: linear-gradient(90deg, #ff8a00, #ff6b6b);">
                  <h5 class="modal-title text-white fw-bold" id="tipModalLabel">
                    <i class="fa fa-heart"></i> Send a Tip
                  </h5>
                  <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <!-- Modal Body -->
                <div class="modal-body p-4">
                  <p class="text-white mb-4">
                    Show your appreciation to <strong>{{ toSentenceCase(escort_data.user_name) }}</strong>
                  </p>

                  <div class="mb-3">
                    <label for="tipAmount" class="form-label text-white fw-bold">Tip Amount ({{ token_label }})</label>
                    <input 
                      id="tipAmount" 
                      type="number" 
                      class="form-control form-control-lg" 
                      v-model="tip_amount" 
                      placeholder="Enter amount..."
                      style="background: #0f3460; color: #ff8a00; border: 1px solid #ff8a00;"
                      required
                    >
                    <small class="text-info d-block mt-2">
                      💡 Your generous tip will be appreciated!
                    </small>
                  </div>

                  <div class="mb-3">
                    <label for="tipMessage" class="form-label text-white fw-bold">Message (Optional)</label>
                    <textarea 
                      id="tipMessage" 
                      rows="3" 
                      class="form-control" 
                      v-model="tip_message" 
                      placeholder="Leave a kind message..."
                      style="background: #0f3460; color: #fff; border: 1px solid #ff8a00;"
                    ></textarea>
                  </div>
                </div>

                <!-- Modal Footer -->
                <div class="modal-footer border-0 pt-2" style="background: rgba(255, 138, 0, 0.1);">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                  <button 
                    type="button" 
                    class="btn btn-warning text-dark fw-bold" 
                    @click="submitTip"
                    :disabled="tip_loading || !tip_amount"
                  >
                    <i v-if="!tip_loading" class="fa fa-send me-2"></i>
                    <i v-else class="fas fa-spinner fa-spin me-2"></i>
                    {{ tip_loading ? 'Sending...' : 'Send Tip' }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Floating Chat Button -->
          <button
              v-if="$store.getters.canViewPhone && escort_data.activation_paid == 1"
              class="floating-chat-btn"
              @click="openChat"
              title="Chat"
            >
              <i class="fa fa-comment"></i>

             <!-- Badge -->
             <span
                v-if="chatHistoryList.length > 0"
                class="chat-badge"
              >
                {{ chatHistoryList.length }}
              </span>
          </button>
    </div>
</template>
<script>
  /* eslint-disable */
import swal from 'sweetalert2';
import PageLoader from '../components/PageLoader.vue'
import { Modal } from 'bootstrap';
import * as bootstrap from 'bootstrap'
import ModelPaidVideoGrid from "@/components/ModelPaidVideoGrid.vue";
import ModelPaidPictureGrid from "@/components/ModelPaidPictureGrid.vue";

export default {

    components: {
        PageLoader,
        ModelPaidVideoGrid,
        ModelPaidPictureGrid
    },
    
    data() {
    return {
        isBooking: false,
        isBookingAmount: true,
        isLoading: false,
        picture_comment: false,
        pageLoader: false,
        image_path: '',
        splashScreen: false,
        selectedImage: null,
        showImageDialog: false,
        selectedVideo: null,
        showVideoDialog: false,
        selectedImageIndex: 0,
        selectedFreeImageIndex: 0,
        selectedVideoIndex: 0,
        showSubscriptionModal: false,
        videos: [],
        paid_videos:[],

        escort_free_pictures: {
          galleries: []
        },

        escort_paid_pictures: {
          galleries: []
        },

        escort_free_videos: {
          galleries: []
        },

        escort_paid_videos: {
          galleries: []
        },

        currentIndex: 0,
        image: {},
        escort_data: {
          galleries: []   // always exists, even before API response
        },

        userid: '',
        activeTab: 'contents',
        tabs: [
          
            { name: 'contents', label: 'Contents' },
            { name: 'photos', label: 'Photos' },
            { name: 'about', label: 'About' },
            { name: 'truthdare', label: "Devil's request" },
            { name: 'review', label: 'Reviews' },
           
        ],
        preferences: [],
        rates: [],
        user_id: '',
        user_role: '',
        countLikes: 0,
        countFollowers: 0,
        image_likes: [],
        escort_video: [],
        likeCountsMap: {}, // holds like counts per image
        videoLikeCountsMap: {}, // holds like counts per image
        user_message: '',
        logoutSplash: false,
        logoutMessage: "",
        services: [],
        apikey: '',
        selectedPlan: '',
        selectedFee: '',
        selectedId: '',
        payment_service: [],
        payment_ref: '',
        user_email: '',

        showStoryViewer: false,
        currentStory: {},
        escortStories: [],
        escortHasStory: '',
        stories: [],
        selectedStoryIndex: 0,
        active_subscriptions: false,
        active_purchases: [],
        media_price: null,
        showTruthDareModal: false,
        model_id: '',
        request_type: '',
        request_details: '',
        reward_token: '',
        deadline: '',
        truthdare_status: false,
        selectedNumber: null,
        selectedModel: '',
        interval: null,
        imageCount: [],
        showPreview: false,
        previewImage: "",
        previewIndex: 0,    // for modal navigation
        profileCount: 0,

        booking_date: '',
        booking_time: '',
        booking_duration: '',
        booking_message: '',
        booking_phone: '',
        booking_amount: '',
        interest_loading: false,
        interestForm: {
          name: '',
          phone: '',
          date: '',
          time: '',
          duration: '',
          budget: '',
          location: '',
          message: ''
        },
        asset_id:'',
        escortid: '',
        showTipModal: false,
        tip_amount: '',
        tip_message: '',
        tip_loading: false,
        freeImgCount: 0,
        freeVideoCount: 0,
        paidVideoCount: 0,
        paidImgCount: 0,
        videoDurations: {},

        model: "",
        reviewer: "",
        rating: 0,
        review: "",
        reviews: [],
        videoLoaded: '',
        model_pictures: [],
        profiles: [],
        paid_profiles: [],
        chatHistoryList: [],
        token_label: process.env.VUE_APP_TOKEN_LABEL,
        walletBalance: 0,
        
      };
    },

    async beforeMount(){
        
        this.user_email = localStorage.getItem("email");
        this.userid =  this.$route.params.escortid; 
        this.user_role = localStorage.getItem("role");
        this.user_id = localStorage.getItem("userid");
    },

    async mounted(){
        await this.listMyProfile(this.userid);
        await this.getConfigData()
        await this.fetchRates(this.userid)
        await this.getFollowers(this.userid)
        await this.listReview()
        await this.createProfileview(this.userid, this.user_id)
        await this.listProfileview(this.userid)
        await this.get_chat_history();


        this.$nextTick(() => {
        document.querySelectorAll('.no-right-click').forEach(img => {
          img.addEventListener('contextmenu', e => {
            e.preventDefault();
            alert("Right-clicking on this image is disabled.");
          });
        });
      });

      this.interval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.escort_free_pictures.galleries.length;
      }, 5000); // change every 5s

    },
    beforeDestroy() {
      clearInterval(this.interval);
    },

  computed: {
  currentImage() {
    const g = this.escort_free_pictures?.galleries?.[this.currentIndex];
    return g?.path || this.escort_data.profilepic;
  },
},

methods: {
  async getWalletbalance(userId) {
    try {

      const response = await this.$http.get(`/fetch-wallets-byuser/${userId}`, {},
      {
          headers: { 
              "x-api-key": `${process.env.VUE_APP_API_KEY}`,
              'Content-Type': 'application/json' 
          }
        }
      )
    
      if (response.data.success) {
        this.walletBalance = response.data.data
      }
  
      } catch (err) { 
          alert(err.response ? err.response.data.message : err.message)
      }
  },
  formatToken(value) {
    const num = Number(value);

    if (!Number.isFinite(num)) {
      return value ?? '0';
    }

    // Keep small values readable, show one decimal for thousands, and cap million-plus at 1m.
    if (num >= 1000000) {
      return '1m';
    }

    if (num >= 1000) {
      const abbreviated = (num / 1000).toFixed(1).replace(/\.0$/, '');
      return `${abbreviated}k`;
    }

    return new Intl.NumberFormat('en-US').format(num);
  },
  async get_chat_history() {
        try {

            const res = await this.$http.get(`/get-client-chat-history`);

            this.chatHistoryList = res.data.data;
        
        } catch (err) {
            console.error("Chat load error:", err);
        }
    },
  openChat() {
    this.handleChat()
  },
  toSentenceCase(text) {
    if (!text) return '';
    return text
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
  },
  tipModel(username) {
    // Open tip modal
    if (!this.user_id) {
      this.logoutMessage = "Please login to send a tip!";
      this.logoutSplash = true;
      setTimeout(() => {
        this.logoutSplash = false;
        this.$router.push('/login');
      }, 2500);
      return;
    }
    //this.showTipModal = true
    this.openTipModal()
  },
  openTipModal() {
    const tipModal = new bootstrap.Modal(document.getElementById('tipModal'));
    tipModal.show();
  },
  closeTipModal() {
    const tipModalEl = document.getElementById('tipModal');
    const tipModal = bootstrap.Modal.getInstance(tipModalEl);
    if (tipModal) {
      tipModal.hide();
    }
  },
  async submitTip() {
    try {
      if (!this.tip_amount) {
        alert('Please enter a tip amount');
        return;
      }
      
      const confirmed = confirm(`Are you sure you want to tip ${this.escort_data.user_name} ${this.tip_amount} tokens?`);
      if (!confirmed) return;

      this.tip_loading = true;

      const response = await this.$http.post('/send-tip', {
        sender_id: this.user_id,
        receiver_id: this.userid,
        amount: this.tip_amount,
        message: this.tip_message || ''
      });

      this.tip_loading = false;

      if (response.data.success) {
        this.logoutMessage = response.data.message || 'Tip sent successfully!';
        this.logoutSplash = true;
        setTimeout(() => {
          this.logoutSplash = false;
          this.closeTipModal();
          this.tip_amount = '';
          this.tip_message = '';
        }, 2500);
        return;
      }
    } catch (err) {
      this.tip_loading = false;
      alert(err.response ? err.response.data.message : err.message);
    }
  },
  loadVideo(){
      this.videoLoaded = true;
  },

  unloadVideo(){
      this.videoLoaded = false;
  },
  setDuration(event, id) {
      const duration = event.target.duration
      if (!isNaN(duration)) {
        const minutes = Math.floor(duration / 60)
        const seconds = Math.floor(duration % 60)
        // use Vue.set for reactivity in Vue 2
        this.$set(this.videoDurations, id, `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`)
      }
    },
    isImage(filePath) {
        return /\.(jpg|jpeg|png|gif|webp)$/i.test(filePath);
    },
    isVideo(filePath) {
        return /\.(mp4|mov|avi|mkv|webm)$/i.test(filePath);
    },
    isImageUnlocked(image_id) {
      // If user has an active subscription, all are unlocked
      if (this.active_subscriptions) return true;

      // If the image_id is in the list of purchased images, unlock
      return this.active_purchases.includes(image_id);
  },

  async submitReview() {
  try{

    if (!this.user_id) {
      setTimeout(() => {
          this.logoutSplash = false;
          this.$router.push('/login');
          }, 2500); // splash visible for 2.5 seconds
          return;
    }
    
    if (
      !this.rating
    ) {
      alert("Please select star rating.");
      return;
    }

    if (
      !this.review
    ) {
      alert("Please enter review.");
      return;
    }

    const response = await this.$http.post('/submit-review', {
          model: this.userid,
          reviewer: this.user_id,
          rating: this.rating,
          review: this.review
        });

         alert(response.data.message)
          // Reset form
          this.model = "",
          this.reviewer = "",
          this.rating = 0,
          this.review = ""

          this.listReview()
          
          return;              
                          
      }catch (err) {
          alert(err.response ? err.response.data.message : err.message)
      }
  },

  async listReview(){
      try{

          const response = await this.$http.get(`/list-reviews/${this.userid}`, {

          });
            this.reviews = response.data.data                 
          }catch (err) {
              console.log(err);
      }
  },

  openBookingModal() {

    if (!this.user_id) {
      setTimeout(() => {
          this.logoutSplash = false;
          this.$router.push('/login');
          }, 2500); // splash visible for 2.5 seconds
          return;
    }

    const bookingChoiceModal = new bootstrap.Modal(document.getElementById('bookingChoiceModal'));
    bookingChoiceModal.show();
  },

  closeBookingChoiceModal() {
    const bookingChoiceModalEl = document.getElementById('bookingChoiceModal');
    const bookingChoiceModal = bootstrap.Modal.getInstance(bookingChoiceModalEl);
    if (bookingChoiceModal) {
      bookingChoiceModal.hide();
    }
  },

  selectBookingOption(option) {
    this.closeBookingChoiceModal();

    if (option === 'interest') {
      this.openShowInterestModal();
      return;
    }

    this.openBookingDetailsModal();
  },

  openBookingDetailsModal() {

    this.isBookingAmount = true;
    this.isBooking = false;

    const bookingModal = new bootstrap.Modal(document.getElementById('bookingModal'));
    bookingModal.show();
  },

  openShowInterestModal() {
    const showInterestModal = new bootstrap.Modal(document.getElementById('showInterestModal'));
    showInterestModal.show();
  },

  closeShowInterestModal() {
    const showInterestModalEl = document.getElementById('showInterestModal');
    const showInterestModal = bootstrap.Modal.getInstance(showInterestModalEl);
    if (showInterestModal) {
      showInterestModal.hide();
    }
  },

  resetShowInterestForm() {
    this.interestForm = {
      name: '',
      phone: '',
      date: '',
      time: '',
      duration: '',
      budget: '',
      location: '',
      message: ''
    };
  },

  async submitShowInterest() {
    try {
      const { name, phone, date, time, duration, budget, location, message } = this.interestForm;

      if (!name || !phone || !date || !time || !duration || !budget || !location || !message) {
        alert('Please fill all interest form fields.');
        return;
      }

      this.interest_loading = true;

       const response = await this.$http.post('/submit-interest', {
        booking_phone: this.interestForm.name + ", " + this.interestForm.phone + ", " + this.interestForm.location, 
        booking_date: this.interestForm.date,
        booking_time: this.interestForm.time,
        booking_amount: this.interestForm.budget,
        booking_duration: this.interestForm.duration,
        booking_message: this.interestForm.message,
        guest_id: this.user_id,
        escort_id: this.userid,
        name: this.interestForm.name,
      });

      this.logoutMessage = `Interest sent to ${this.escort_data.user_name} successfully!`;
      this.logoutSplash = true;

      setTimeout(() => {
        this.interest_loading = false;
        this.logoutSplash = false;
        this.closeShowInterestModal();
        this.resetShowInterestForm();
      }, 2000);
    } catch (err) {
      this.interest_loading = false;
      alert(err.response ? err.response.data.message : err.message);
    }
  },

  closeBookingModal() {
  const bookingModalEl = document.getElementById('bookingModal');
  const bookingModal = bootstrap.Modal.getInstance(bookingModalEl); 
  if (bookingModal) {
    bookingModal.hide();
  }
},

async check_booking_amount(){
  try{

        const response = await this.$http.post('/check-wallet-balance', {
          userid: this.user_id,
          amount: this.booking_amount
        });

       if (response.data.success) {
          this.isBookingAmount = false
          this.isBooking = true
          return;              
        }  
                          
      }catch (err) {
          alert(err.response ? err.response.data.message : err.message)
      }
  },

  async submit_booking(){
    try{

      const confirmed = confirm("Are you sure you want to proceed with the booking?");
      if (!confirmed) return; // Stop execution if user cancels

      const response = await this.$http.post('/submit-booking', {
        booking_amount: this.booking_amount,
        booking_date: this.booking_date,
        booking_time: this.booking_time,
        booking_duration: this.booking_duration,
        booking_message: this.booking_message,
        booking_phone: this.booking_phone,
        guest_id: this.user_id,
        escort_id: this.userid
      });

        if (response.data.success) {
          // Set splash message
          this.logoutMessage = response.data.message || "Successful!";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          this.closeBookingModal()
          window.location.reload()
          }, 2500); // splash visible for 2.5 seconds
          return;              
        }  
                          
      }catch (err) {
          console.log(err);
          alert(err.response ? err.response.data.message : err.message)
      }
  },

  async createProfileview(profile_id, viewer_id){
        try{

            this.response = await this.$http.post('/create-profile-view', {
              profile_id: profile_id,
              viewer_id: viewer_id
            });
                                
            }catch (err) {
                console.log(err);
        }
  },

  async listProfileview(profile_id){
        try{

           const response = await this.$http.get(`/list-profile-view/${profile_id}`, {

            });
             this.profileCount = response.data.data                 
            }catch (err) {
                console.log(err);
        }
  },

  prevImage() {
    if (this.previewIndex > 0) {
      this.previewIndex--
    } else {
      this.previewIndex = this.escort_free_pictures.galleries.length - 1
    }
  },
  nextImage() {
    if (this.previewIndex < this.escort_free_pictures.galleries.length - 1) {
      this.previewIndex++
    } else {
      this.previewIndex = 0
    }
  },

  openContactModal(number, username) {
     if (!this.user_id) {
      this.logoutMessage = "Please login to view contact details!";
      this.logoutSplash = true;
      setTimeout(() => {
        this.logoutSplash = false;
        this.$router.push('/login');
      }, 2500);
      return;
    }
    
    this.selectedNumber = number;
    this.selectedModel = username;
    const modal = new bootstrap.Modal(document.getElementById('contactModal'));
    modal.show();
  },
  dialNumber(number) {
    window.location.href = `tel:${number}`;
  },
  whatsappNumber(number) {
    const cleanNumber = number.replace(/\D/g, '');
    window.open(`https://wa.me/${cleanNumber}`, '_blank');
  },

  openPreview(imagePath) {
    this.previewImage = imagePath
    this.showPreview = true
  },

  closePreview() {
    this.showPreview = false
    this.previewImage = ""
  },

  openTruthDareModal() {

    if (!this.active_subscriptions) {
        // Set splash message
        this.logoutMessage = `Please subscribe to ${this.escort_data.user_name} plan`;
        this.logoutSplash = true;
        // Wait before redirecting
        setTimeout(() => {
        this.logoutSplash = false;
        }, 2500); // splash visible for 2.5 seconds

        this.openSubscription(null);
        return;
    }

    if (!this.user_id) {
        // Set splash message
        this.logoutMessage = `Please login to make request to ${this.escort_data.user_name}`;
        this.logoutSplash = true;
        // Wait before redirecting
        setTimeout(() => {
        this.logoutSplash = false;
        }, 2500); // splash visible for 2.5 seconds
        return;
    }

    this.showTruthDareModal = true;
  },
  closeTruthDareModal() {
    this.showTruthDareModal = false;
    this.resetTruthDareForm();
  },
  resetTruthDareForm() {
      this.request_type = '',
      this.request_details ='',
      this.reward_token ='',
      this.deadline = ''
  },
  async submitTruthDareRequest() {
    try{
        if(!this.request_type || !this.request_details || !this.reward_token || !this.deadline) {
          this.truthdare_status = false
          alert("Please fill all fields.")
          return;
        }
            
        this.truthdare_status = true

        const response = await this.$http.post('/create-truthdare', {
            client_id: this.user_id, //client id
            model_id: this.userid, // model id
            request_type: this.request_type,
            request_details: this.request_details,
            reward_token: this.reward_token,
            deadline: this.deadline,
        });

        this.truthdare_status = false

        if (response.data.success) {
              // Set splash message
              this.logoutMessage = response.data.message || "Successful!";
              this.logoutSplash = true;
              // Wait before redirecting
              setTimeout(() => {
              this.closeTruthDareModal()
              window.location.reload();
              this.logoutSplash = false;
              }, 2500); // splash visible for 2.5 seconds
              return;              
          }                 
        }catch (err) {
          this.truthdare_status = false
          alert(err.response ? err.response.data.message : err.message)
    }
  },

  async purchaseAssets(price, asset_id) {
  try {
    // Add confirmation alert before proceeding
    const confirmed = confirm("Are you sure you want to buy this asset?");
    if (!confirmed) return; // Stop execution if user cancels

    const response = await this.$http.post('/create-media-purchase', {
      client_id: this.user_id,  // client id
      model_id: this.escortid,  // model id
      asset_id: asset_id,
      amount: price,
    });

    if (response.data.success) {
      // Set splash message
      alert(response.data.message || "Successful!");
      this.showSubscriptionModal = false;
      window.location.reload();
      return;
    }
  } catch (err) {
    this.truthdare_status = false;
    alert(err.response ? err.response.data.message : err.message);
  }
  },

  openSubscription(price, asset_id) {
    if (!this.user_id) {
          // Set splash message
          this.logoutMessage = "Please login to continue!";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          this.$router.push('/login');
          }, 2500); // splash visible for 2.5 seconds
          return;
    }
    this.media_price = price
    this.asset_id = asset_id
    this.showSubscriptionModal = true;
  },
  closeSubscription() {
    this.showSubscriptionModal = false;
  },
  maskPhoneNumber(phone) {
      if (!phone) return '';
      return phone.slice(0, 4) + '*'.repeat(phone.length - 4);
  },
  openStoryModal(index = 0) {
    this.selectedImageIndex = index;
    const modalEl = document.getElementById('storyModal');
    const modal = new Modal(modalEl);
    modal.show();
  },
  closeModalx() {
    const modalEl = document.getElementById('storyModal');
    const modalInstance = Modal.getInstance(modalEl);

    if (modalInstance) {
      modalInstance.hide();
    }
  },

  async openStory() {
    this.openStoryModal();
  },

  // Show story viewer modal
  async openStoryViewer(escortid) {
    try {
      const response = await this.$http.get(`/fetch-stories/${escortid}`);
      this.stories = response.data.data
      //console.log(this.stories);
      if (this.stories.length > 0) {
        this.escortHasStory  = this.stories
      }
    } catch (err) {
      console.error('Error loading stories:', err);
    }
  },

  async getConfigData(){
      const response = await fetch('/config.json');
      const configData = await response.json();
      this.apikey = configData.apikey;
  },

  openImageModal(index) {
  this.selectedImageIndex = index;
  const modalEl = document.getElementById('imageModal');
  const modal = new Modal(modalEl);
  modal.show();
},

openFreeImageModal(index) {
  this.selectedFreeImageIndex = index;
  const modalEl = document.getElementById('freeImageModal');
  const modal = new Modal(modalEl);
  modal.show();
},

openVidModal(index) {
  this.selectedVideoIndex = index;
  const modalEl = document.getElementById('vidModal');
  const modal = new Modal(modalEl);
  modal.show();
},

closeFreeModal() {
  const modalEl = document.getElementById('freeImageModal');
  const modalInstance = Modal.getInstance(modalEl);

  if (modalInstance) {
    modalInstance.hide();
  }
},

closeModal() {
  const modalEl = document.getElementById('imageModal');
  const modalInstance = Modal.getInstance(modalEl);

  if (modalInstance) {
    modalInstance.hide();
  }
},

closeVidModal() {
  const modalEl = document.getElementById('vidModal');
  const modalInstance = Modal.getInstance(modalEl);

  if (modalInstance) {
    modalInstance.hide();
  }
},

  async fetchServices(escortid) {
      try {
        const response = await this.$http.get(`/list-escort-subscription-plans/${escortid}`);
        if (response.data.success) {
          this.services = response.data.data;
        } else {
          this.logoutMessage = response.data.message || "Failed to load services";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
        }
      } catch (err) {
        console.error(err);
        this.logoutMessage = "An error occurred while fetching services";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
      }
  },

  async fetchActiveSubscription(escortid, user_id) {
      try {
        const response = await this.$http.get(`/get-active-subscriptions/${escortid}/${user_id}`);
        if (response.data.success) {
          const services = response.data.data;
          // Check if services is not null/undefined and has at least one record
          if (services && Array.isArray(services) && services.length > 0) {
            this.active_subscriptions = true;
          } else {
            this.active_subscriptions = false;
          }

        } else {
          this.logoutMessage = response.data.message || "Failed to load services";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
        }
      } catch (err) {
        console.error(err);
          this.logoutMessage = "An error occurred while fetching services";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
      }
  },

  async fetchActivePurchases(escortid, user_id) {
      try {
        const response = await this.$http.get(`/get-active-purchases/${escortid}/${user_id}`);
        if (response.data.success) {
          const purchases = response.data.data;
          // Check if services is not null/undefined and has at least one record
          if (Array.isArray(purchases) && purchases.length > 0) {
            // store all purchased image IDs for easy lookup
            this.active_purchases = purchases.map(item => item.asset_id);
            //console.log(this.active_purchases)
          } else {
            this.active_purchases = [];
          }
        } else {
          this.active_purchases = [];
          this.logoutMessage = response.data.message || "Failed to load services";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
        }
      } catch (err) {
          console.error(err);
          this.logoutMessage = "An error occurred while fetching services";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds
      }
  },

  parseServiceType(serviceType) {
  try {
    // If it's already an object, return it directly
    if (typeof serviceType === 'object') {
      return serviceType;
    }

    // If it's a JSON string, parse it
    if (typeof serviceType === 'string') {
      return JSON.parse(serviceType);
    }

    // If it’s neither string nor object, return empty object
    return {};
  } catch (error) {
    console.error("Error parsing service_type:", error);
    return {};
  }
  },

  async sendMessage(){
        try{
            
            this.message_status = true
            this.response = await this.$http.post('/send-message', {
                userid: this.user_id,
                message: this.user_message
            });
    
            this.message_status = false
    
            if (!this.response.data.success) {
                swal.fire({
                    title: 'error',
                    width:350,
                    height:3,
                    text: this.response.data.message,
                    });
                    return;
    
                } else {
    
                   // Set splash message
                    this.logoutMessage = this.response.data.message || "Successful!";
                    this.logoutSplash = true;
                    // Wait before redirecting
                    setTimeout(() => {
                    this.logoutSplash = false;
                    }, 2500); // splash visible for 2.5 seconds
                    this.picture_comment = false
                    return;              
    
            }
                                
            }catch (err) {
                console.log(err);
        }
  },

   openImage(index) {
    this.selectedImageIndex = index;
    this.showImageDialog = true;
   },


    formatPrice(value) {
      return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
      minimumFractionDigits: 2
    }).format(value);
    },

    backProfile() {
        this.profile = true,
        this.edit_profile = false
    },

    async listMyProfile(userid){
         try{
            this.isLoading = true
            const response = await this.$http.post('/list-escort-info',{ user_id: userid} )
            this.escort_data = response.data.data;
            this.escortid = this.escort_data.escortid
            this.isLoading = false

            
            if (this.user_role == "guest") {
              await this.fetchActiveSubscription(this.escort_data.user_id, this.user_id)
              //await this.fetchActivePurchases(this.escort_data.escortid, this.user_id)
            }
           
            await this.listPaidVideos(this.escort_data.escortid)
            await this.listEscortPaidPictures(this.escort_data.escortid)
            await this.listEscortPreferences(this.escort_data.escortid)
            await this.fetchServices(this.escort_data.user_id);
            await this.openStoryViewer(this.escort_data.user_id);
            await this.getWalletbalance(this.escort_data.user_id)

            }catch (err) {
                console.log(err);
            }
    },

    async listEscortVideos(userid){
         try{

          const response = await this.$http.post('/list-escort-videos-byuser',{ user_id: userid} )
          this.escort_video = response.data.data;

          if (this.escort_video.videos && Object.keys(this.escort_video.videos).length > 0) {
            Object.values(this.escort_video.videos).forEach(videos => {
              this.fetchVideoLikeCount(videos);
            });
          }

          }catch (err) {
              console.log(err);
        }
    },

    async listPaidVideos(escort_id){
        try{

            const response = await this.$http.get(`/get-paid-videos/${escort_id}`,{} )
            this.escort_paid_videos = response.data.data || { galleries: [] };
            this.paidVideoCount = response.data.data.galleries.length

           // Map API data to ProfileGrid format
            this.paid_videos = this.escort_paid_videos.galleries.map(r => ({
              id: r.id,
              escort_user_id: r.escort_user_id,
              title: r.description,
              file_path: r.path,
              thumbnail: r.thumb_path,
              is_premium: r.is_premium,
              dayruns_token: r.dayruns_token,
              price: r.price,
              locked: r.is_premium !== "free",
              likes: r.likes,
              duration: r.video_duration,
              userid: r.escort_id,
              
            }));
            this.currentPage = 1; // reset page on reload

            }catch (err) {
            console.log(err);
        }
    },

    async listEscortPaidPictures(escort_id){
         try{

          const response = await this.$http.get(`/get-paid-pictures/${escort_id}`,{} )
          if (response.data.data !== null) {
              this.escort_paid_pictures = response.data.data || { galleries: [] };
              this.paidImgCount = response.data.data.galleries.length

              // Map API data to ProfileGrid format
              this.paid_profiles = this.escort_paid_pictures.galleries.map(r => ({
              id: r.id,
              escort_user_id: r.escort_user_id,
              title: r.description,
              image: r.path,
              is_premium: r.is_premium,
              dayruns_token: r.dayruns_token,
              price: r.price,
              locked: r.is_premium !== "free",
              likes: r.likes,
              userid: r.escort_id,
              }));
              this.currentPage = 1; // reset page on reload

            } else {
              this.escort_paid_pictures = {
                galleries: []
              };
            }

          }catch (err) {
              console.log(err);
        }
    },

    async listEscortPreferences(escortid){
         try{
            const response = await this.$http.post('/list-escort-preferences',{ escort_id: escortid} )
            
            const first = response.data.data[0];

            if (!first || first === '') {
              this.preferences = [{ username: this.escort_data.user_name }];
            } else {
              this.preferences = first;
            }

            }catch (err) {
                console.log(err);
        }
    },

    async fetchRates(userid) {
        try {
        const res = await this.$http.get(`/list-escort-rates/${userid}`);
        if (res.data.success && res.data.data.length > 0) {
            this.rates = res.data.data;
        } else {
           // this.rates = [{ duration: '', inCall: '', outCall: '' }];
        }
        } catch (err) {
        console.error('Failed to fetch rates', err);
        }
    },

    async bookService(service){
      try {
        if (!this.user_id) {
          // Set splash message
          this.logoutMessage = "Please login to subscribe for this plan!";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          this.$router.push('/login');
          }, 2500); // splash visible for 2.5 seconds
          return;
        }

        const confirmed = confirm("Proceed to subscribe?");
        if (!confirmed) return; // Stop execution if user cancels

        this.selectedFee = service.dayruns_token
        this.selectedPlan = service.category
        this.selectedId = service.id
        this.payment_service = service
        const payment_reference = "PAY-" + Date.now();
        
        this.pay(this.user_id, this.payment_service, payment_reference)
        
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async pay(user_id, payment_service, payment_reference) {
        try{
          const response = await this.$http.post('/book-escort-service', {
            user_id: user_id,
            service: payment_service,
            payment_reference: payment_reference
          });

        if (response.data.success) {
        // Set splash message
        this.logoutMessage = response.data.message || "Payment Successful!";
        this.logoutSplash = true;
        // Wait before redirecting
        setTimeout(() => {
            this.logoutSplash = false
            this.showSubscriptionModal = false;
            alert(`Plan "${this.selectedPlan}" activated!`);    
            window.location.reload();
        }, 2500); // splash visible for 2.5 seconds

        } else {

           // Set splash message
           alert(response.data.message)
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds

        }
             
        }catch (err) {
          this.loading = false;
          alert(err.response ? err.response.data.message : err.message)

          console.log(err);
      }

    },

    async handleFollow() {
    try {
        if (!this.user_id) {
          // Wait before redirecting
          setTimeout(() => {
          this.$router.push("/login")
          }, 500); // splash visible for 5 seconds

          return;
        }

      if (this.escort_data && this.escort_data.id) {
        const response = await this.$http.post('/follow-escort', {
          escort_id: this.escort_data.escortid,
          followed_by: this.user_id,
        });

        if (response.data.success) {
        
          this.getFollowers(this.userid)

          // Set splash message
          this.logoutMessage = response.data.message || "Follow Successful!";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds

        } else {
         
           // Set splash message
          this.logoutMessage = response.data.message || "Follow Successful!";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds

        }
      }
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async handleUnFollow() {
    try {
        if (!this.user_id) {
          // Set splash message
          //this.logoutMessage = "Please login to unfollow this escort!";
          //this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          //this.logoutSplash = false;
          this.$router.push("/login")
          }, 500); // splash visible for 5 seconds
          return;
        }

      if (this.escort_data && this.escort_data.id) {
        const response = await this.$http.post('/unfollow-escort', {
          escort_id: this.escort_data.escortid,
          followed_by: this.user_id,
        });

        if (response.data.success) {

          this.getFollowers(this.userid)

          // Set splash message
          this.logoutMessage = response.data.message || "Unfollow Successful!";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds

        } else {

           // Set splash message
          this.logoutMessage = response.data.message || "Unfollow Successful!";
          this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          this.logoutSplash = false;
          }, 2500); // splash visible for 2.5 seconds

        }
      }
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async getFollowers(userid) {
    try {

        const response = await this.$http.get(`/escort-followers/${userid}`, {});
        this.countFollowers = response.data.data.length
      
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async handleChat() { 
        if (!this.user_id) {
           // Set splash message
          //this.logoutMessage = "Please login to chat this escort.";
          //this.logoutSplash = true;
          // Wait before redirecting
          setTimeout(() => {
          //this.logoutSplash = false;
          this.$router.push("/login")
          }, 500); // splash visible for 5 seconds
          return;
        }
        this.$router.push(`/chat/${this.escort_data.user_id}/${this.escort_data.user_name}`)
    },

    async handleComment(image) {
    try {
      image

      this.picture_comment = true
      //
      
    } catch (err) {
     //
    }
    },
  }
}

</script>

<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');
.form-label{
  font-weight: 600;
}
.chat-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;

  background: #ff3b30;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 999px;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
}

.floating-chat-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #D33E74, #D33E74);
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.floating-chat-btn i {
  font-size: 22px;
}

.floating-chat-btn:hover {
  transform: scale(1.08);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.4);
}

h5{
  color: #D33E74 !important;
  //text-align: center;
}
.btn-success{
  background: #D33E74;
  border: none;
}
.video-player {
  width: 100%;
  height: auto;
  max-height: 100%;
  background: #000;
  aspect-ratio: 4/5;
}
video {
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}
.bg-success{
  background: #D33E74 !important;
  border: none;
  font-weight: 400 !important;
  font-size: 10px !important;
}

.modal-header{
  background: #D33E74 !important;
}
.booking-modal-card{
  overflow: hidden;
  border: 0;
  border-radius: 24px;
  background: linear-gradient(180deg, #13111c 0%, #0f1728 100%);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
}

.booking-choice-card{
  overflow: hidden;
  border: 0;
  border-radius: 22px;
  background: linear-gradient(180deg, #13111c 0%, #0f1728 100%);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
}

.booking-choice-grid{
  display: grid;
  gap: 12px;
}

.booking-choice-btn{
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  text-align: left;
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}

.booking-choice-btn i{
  font-size: 1rem;
  color: #f9a8d4;
}

.booking-choice-btn span{
  display: flex;
  flex-direction: column;
}

.booking-choice-btn strong{
  font-size: 0.95rem;
  font-weight: 700;
}

.booking-choice-btn small{
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.82rem;
}

.booking-choice-btn:hover{
  transform: translateY(-1px);
  border-color: rgba(211, 62, 116, 0.35);
  background: rgba(211, 62, 116, 0.1);
  color: #fff;
}

.booking-modal-header{
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  padding: 24px 24px 20px;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.95), rgba(106, 17, 203, 0.95));
  color: #fff;
}

.booking-modal-title-wrap{
  max-width: 85%;
}

.booking-eyebrow{
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.9);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.booking-modal-title{
  margin-top: 10px;
  color: #fff !important;
  font-size: 1.35rem;
  font-weight: 800;
}

.booking-modal-subtitle{
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.95rem;
  line-height: 1.5;
}

.booking-close-btn{
  opacity: 1;
  box-shadow: none;
  filter: none;
}

.contact-modal-dialog{
  max-width: 520px;
}

.contact-modal-card{
  overflow: hidden;
  border: 0;
  border-radius: 24px;
  background: linear-gradient(180deg, #13111c 0%, #0f1728 100%);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
}

.contact-modal-header{
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  padding: 24px 24px 20px;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.96), rgba(106, 17, 203, 0.92));
  color: #fff;
}

.contact-modal-title-wrap{
  max-width: 86%;
}

.contact-eyebrow{
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.9);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.contact-modal-title{
  margin-top: 10px;
  color: #fff !important;
  font-size: 1.3rem;
  font-weight: 800;
  line-height: 1.35;
}

.contact-name{
  color: #ffe28a;
}

.contact-modal-subtitle{
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.95rem;
  line-height: 1.5;
}

.contact-close-btn{
  opacity: 1;
  box-shadow: none;
  filter: none;
}

.contact-modal-body{
  padding: 24px;
}

.contact-summary-card{
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
  padding: 16px 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
}

.contact-icon-pill{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.22), rgba(255, 138, 0, 0.2));
  color: #fff;
  flex-shrink: 0;
}

.contact-summary-label{
  color: rgba(255, 255, 255, 0.64);
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.contact-summary-value{
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
  word-break: break-word;
}

.contact-actions{
  display: grid;
  gap: 12px;
}

.contact-action-btn{
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 16px;
  border: 0;
  border-radius: 16px;
  color: #fff;
  text-align: left;
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.contact-action-btn i{
  font-size: 1.1rem;
}

.contact-action-btn span{
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contact-action-btn strong{
  font-size: 0.98rem;
  font-weight: 700;
}

.contact-action-btn small{
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.82rem;
}

.contact-action-btn--call{
  background: linear-gradient(135deg, #0ea5e9, #2563eb);
  box-shadow: 0 14px 28px rgba(37, 99, 235, 0.24);
}

.contact-action-btn--whatsapp{
  background: linear-gradient(135deg, #25d366, #159957);
  box-shadow: 0 14px 28px rgba(21, 153, 87, 0.24);
}

.contact-action-btn:hover{
  transform: translateY(-1px);
  filter: brightness(1.02);
}

.contact-modal-footnote{
  margin-top: 14px;
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.84rem;
  line-height: 1.5;
  text-align: center;
}

.modal-booking-dialog{
  max-width: 760px;
}

.booking-modal-body{
  padding: 24px;
}

.booking-summary-card{
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}

.booking-summary-chip{
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.88);
  font-size: 0.9rem;
}

.booking-step-indicator{
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.booking-step{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.68);
  font-size: 0.85rem;
  font-weight: 700;
}

.booking-step.active{
  background: rgba(211, 62, 116, 0.16);
  border-color: rgba(211, 62, 116, 0.34);
  color: #fff;
}

.booking-panel{
  padding: 22px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.booking-panel-header{
  margin-bottom: 18px;
}

.booking-panel-title{
  margin-bottom: 6px;
  color: #fff;
  font-size: 1.05rem;
  font-weight: 800;
}

.booking-panel-text{
  margin-bottom: 0;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.92rem;
  line-height: 1.5;
}

.booking-label{
  margin-bottom: 8px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.86rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.booking-control{
  min-height: 48px;
  background: rgba(10, 12, 20, 0.7) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
  border-radius: 14px;
  box-shadow: none !important;
}

.booking-control::placeholder{
  color: rgba(255, 255, 255, 0.42);
}

.booking-control:focus{
  border-color: rgba(211, 62, 116, 0.6) !important;
  box-shadow: 0 0 0 0.2rem rgba(211, 62, 116, 0.18) !important;
}

.booking-textarea{
  min-height: 120px;
  resize: vertical;
}

.booking-help-text{
  margin-top: 8px;
  margin-bottom: 0;
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.82rem;
  line-height: 1.45;
}

.booking-actions{
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

.booking-actions--single{
  justify-content: flex-end;
}

.booking-btn{
  min-width: 140px;
  min-height: 44px;
  border-radius: 999px;
  padding: 0.65rem 1.2rem;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.booking-btn--primary{
  background: linear-gradient(135deg, #d33e74, #6a11cb);
  border: none;
  color: #fff;
}

.booking-btn--primary:hover{
  filter: brightness(1.05);
  color: #fff;
}

.booking-btn--ghost{
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: rgba(255, 255, 255, 0.92);
}

.booking-btn--ghost:hover{
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}

.booking-modal-card .btn-close{
  box-shadow: none;
}

@media (max-width: 576px) {
  .booking-modal-header{
    padding: 20px 18px 16px;
  }

  .booking-modal-body{
    padding: 18px;
  }

  .booking-panel{
    padding: 18px;
  }

  .booking-actions{
    flex-direction: column-reverse;
  }

  .booking-btn{
    width: 100%;
  }

  .booking-summary-chip{
    width: 100%;
  }
}
.btn-buy{
  color: #D33E74;
}
.blurred-img {
  filter: blur(8px); /* adjust blur strength */
}
.disabled-video {
  pointer-events: none;
  opacity: 0.9;
  filter: brightness(0.7);
}

/* Navigation buttons */
.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255,255,255,0.7);
  border: none;
  font-size: 30px;
  padding: 5px 15px;
  cursor: pointer;
  border-radius: 50%;
}
.prev-btn { left: 0px; }
.next-btn { right: 0px; }

@media screen and (max-width: 768px) {
  .row{
    padding: 0.9rem;
}
}
/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-content-bg {
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  width: 80%;
  height: 80%;
}

@media screen and (max-width: 700px) {
  .modal-content-bg {
    position: relative;
    width: 100%;
    height: 80%;
  }

  .preview-img {
    border-radius: 0px !important;
  }
}

.preview-img {
  max-width: 100vw;
  min-height: 100%;
  border-radius: 10px;
}
.preview-img,
.preview-video {
  max-width: 100%;
  max-height: 80vh;
  border-radius: 8px;
  display: block;
  margin: auto;
}
.cursor-pointer{
  cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: white;
  border: none;
  font-size: 18px;
  padding: 5px 10px;
  border-radius: 50%;
  cursor: pointer;
}

.bg-slide,
.bg-slide1 {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 0;
  animation: slideBackground 10s infinite alternate;
  width: 100%;
  
  /* Responsive Height using aspect ratio + min-height */
  aspect-ratio: 16 / 9;           /* Good default for hero/cover images */
  min-height: 180px;              /* Minimum height on very small screens */
  max-height: 320px;              /* Prevent it from becoming too tall */
  
  /* Fallback for older browsers */
  height: 220px;
}

/* Mobile phones */
@media (max-width: 576px) {
  .bg-slide,
  .bg-slide1 {
    aspect-ratio: 4 / 3;          /* Taller on mobile */
    min-height: 260px;
  }
}

/* Tablets */
@media (min-width: 577px) and (max-width: 992px) {
  .bg-slide,
  .bg-slide1 {
    aspect-ratio: 16 / 9;
    min-height: 200px;
  }
}

/* Large screens */
@media (min-width: 993px) {
  .bg-slide,
  .bg-slide1 {
    aspect-ratio: 21 / 9;         /* Wider feel on desktop */
    min-height: 260px;
  }
}

@media screen and (max-width: 700px) {
  .bg-slide { margin-bottom: 45%;  padding: 0; }
  .bg-slide1 { margin-bottom: 35%;  padding: 0; }

  .card-body{
    h5{
      text-transform: capitalize;
      font-size: 13px;
    }
    p{
      font-size: 11px;
    }
    .btn-primary{
      font-size: 12px;
    }
  }
  
}

@media (max-width: 576px) {
  .contact-modal-dialog {
    max-width: 100%;
    margin: 1rem auto;
  }

  .contact-modal-header {
    padding: 18px 18px 16px;
  }

  .contact-modal-body {
    padding: 18px;
  }

  .contact-modal-title {
    font-size: 1.1rem;
  }

  .contact-modal-subtitle {
    font-size: 0.9rem;
  }

  .contact-summary-card {
    align-items: flex-start;
  }

  .contact-action-btn {
    padding: 13px 14px;
  }
}

@keyframes slideBackground {
  from {
    background-position: left center;
  }
  to {
    background-position: right center;
  }
}
.bio-tab{
    //margin-top: 135px !important;
    //background: #111112;
}

.profile-tabs {
  gap: 0.65rem;
  padding: 0.5rem;
  border: 1px solid rgba(211, 62, 116, 0.16);
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.02));
}

.profile-tabs .nav-item {
  flex: 0 0 auto;
}

.profile-tabs .nav-link {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.72rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: #e5e7eb;
  font-family: 'Raleway';
  font-size: 0.88rem;
  font-weight: 600;
  transition: 0.2s ease;
}

.profile-tabs .nav-link:hover {
  transform: translateY(-1px);
  border-color: rgba(211, 62, 116, 0.35);
  color: #fff;
}

.profile-tabs .nav-link.active {
  border-color: rgba(211, 62, 116, 0.45);
  background: linear-gradient(135deg, #D33E74, #b82f62);
  color: #fff;
  box-shadow: 0 12px 24px rgba(211, 62, 116, 0.28);
}

.profile-tab-content {
  padding: 0.35rem;
}

.tab-panel-shell {
  padding: 0.5rem 0.15rem 0.25rem;
}

.truth-panel,
.review-panel {
  padding: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(16, 16, 20, 0.98), rgba(22, 22, 28, 0.96));
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.24);
}

.truth-panel > h5,
.review-panel > h5 {
  color: #fff;
  font-size: 1.1rem;
  font-weight: 800;
}

.truth-panel p {
  padding: 0;
  margin: 0.75rem 0 0;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.75;
}

.review-panel > h5 {
  margin-bottom: 1rem !important;
}

.tab-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.9rem;
}

.panel-eyebrow {
  margin: 0;
  color: #d33e74;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.panel-title {
  margin: 0.15rem 0 0;
  color: #fff;
  font-size: 1.15rem;
  font-weight: 800;
}

.tab-panel-card {
  padding: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(16, 16, 20, 0.98), rgba(22, 22, 28, 0.96));
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.24);
}

.tab-panel-card .bio-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.75rem;
}

.tab-panel-card .profile-preference {
  padding: 0.9rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
}

.tab-panel-card .profile-preference h6 {
  margin-bottom: 0.25rem;
  color: rgba(255, 255, 255, 0.72);
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.tab-panel-card .profile-preference small {
  color: #fff;
  font-size: 0.92rem;
}

.tab-panel-card .bio-content-text {
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.8;
}

.tab-panel-card .rate-display-section,
.tab-panel-card .preferences-list {
  margin-top: 1.25rem;
}

.tab-copy {
  margin-bottom: 1rem;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.75;
}

.section-row {
  margin-bottom: 0.75rem;
}

.section-subtitle {
  margin: 0;
  color: #fff;
  font-size: 0.98rem;
  font-weight: 700;
}

.section-helper {
  margin: 0.25rem 0 0;
  color: rgba(255, 255, 255, 0.58);
  font-size: 0.88rem;
}

.rate-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 0.9rem;
  margin-top: 0.85rem;
}

.rate-card {
  padding: 0.95rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
}

.rate-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-bottom: 0.65rem;
  border-radius: 12px;
  background: rgba(211, 62, 116, 0.15);
  color: #f9a8d4;
}

.rate-duration {
  margin-bottom: 0.35rem;
  color: #fff;
  font-weight: 700;
}

.rate-price {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
}

.preferences-list {
  margin-top: 1rem;
}

.preference-item,
.preference-item-p {
  padding: 0.9rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
}

.preference-item strong {
  display: block;
  margin-bottom: 0.3rem;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.services-panel {
  padding: 0.95rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
}

.services-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.service-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.45rem 0.75rem;
  border: 1px solid rgba(211, 62, 116, 0.18);
  border-radius: 999px;
  background: rgba(211, 62, 116, 0.08);
  color: #fff;
  font-size: 0.85rem;
}

.callout-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.85rem;
}

.callout-item {
  display: flex;
  gap: 0.85rem;
  padding: 0.95rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
}

.callout-item i {
  margin-top: 0.15rem;
  color: #D33E74;
  font-size: 1rem;
}

.callout-item h6 {
  margin-bottom: 0.25rem;
  color: #fff;
  font-size: 0.92rem;
  font-weight: 700;
}

.callout-item p {
  margin: 0;
  color: rgba(255, 255, 255, 0.68);
  font-size: 0.86rem;
  line-height: 1.55;
}

.request-cta {
  border-color: #D33E74 !important;
  background: linear-gradient(135deg, #D33E74, #b82f62) !important;
  box-shadow: 0 12px 28px rgba(211, 62, 116, 0.28);
}

.review-panel .tab-panel-card {
  padding: 1rem 1rem 1.15rem;
}

.review-card {
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
}

.review-card .card-body {
  padding: 1rem;
}

.review-author {
  color: #fff;
  font-size: 0.95rem;
  font-weight: 700;
}

.review-date {
  color: rgba(255, 255, 255, 0.55);
  font-size: 0.78rem;
}

.review-rating {
  white-space: nowrap;
}

.review-text {
  margin-bottom: 0;
  color: rgba(255, 255, 255, 0.82);
  white-space: pre-wrap;
  line-height: 1.7;
}

.empty-reviews {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 1rem;
  border: 1px dashed rgba(255, 255, 255, 0.18);
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.72);
}

.empty-reviews i {
  margin-bottom: 0.5rem;
  color: #D33E74;
  font-size: 1.25rem;
}

.review-form {
  padding-top: 0.25rem;
}

.review-input {
  min-height: 110px;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-radius: 14px !important;
  background: rgba(255, 255, 255, 0.05) !important;
  color: #fff !important;
}

.review-input::placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.review-submit {
  border: 0;
  border-radius: 14px;
  background: linear-gradient(135deg, #D33E74, #b82f62);
  box-shadow: 0 12px 28px rgba(211, 62, 116, 0.28);
}

.tab-panel-shell .btn-primary {
  border-radius: 14px;
}

@media screen and (max-width: 700px) {
  .profile-tabs {
    gap: 0.45rem;
    padding: 0.4rem;
  }

  .profile-tabs .nav-link {
    padding: 0.6rem 0.85rem;
    font-size: 0.8rem;
  }

  .tab-panel-header {
    align-items: flex-start;
  }

  .tab-panel-card {
    padding: 0.85rem;
  }

  .rate-list,
  .callout-grid {
    grid-template-columns: 1fr;
  }

  .review-card .card-body {
    padding: 0.85rem;
  }

  .review-submit {
    font-size: 0.95rem;
  }
}

.subscribe{
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 10px;
}
.subscribe-btn{
  background: #D33E74;
  color: #fff;
  border: 0 solid;
  padding: 0.5rem;
  border-radius: 10px;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
}
/* Target ONLY the video modal carousel */
#escortVideoCarousel .carousel-item-next.carousel-item-start,
#escortVideoCarousel .carousel-item-prev.carousel-item-end {
  transform: translateY(0);
}

#escortVideoCarousel .carousel-item-next,
#escortVideoCarousel .active.carousel-item-end {
  transform: translateY(100%);
}

#escortVideoCarousel .carousel-item-prev,
#escortVideoCarousel .active.carousel-item-start {
  transform: translateY(-100%);
}

.user-select-none {
  user-select: none;
  -webkit-user-drag: none;
  -webkit-touch-callout: none;
}

.blurred {
  filter: blur(20px);
  cursor: pointer;
}
.blurred-vid {
  filter: blur(2px);
  cursor: pointer;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.modal-subs {
  background: white;
  padding: 0px;
  margin: 100px auto;
  border-radius: 10px;
  font-family: 'Raleway' !important;
  font-style: normal !important;
  font-weight: 500;
  font-size: 13px;
  width: 90%;
}
.subs-content{
  padding: 10px;
}
.story-viewer-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}

.story-backdrop {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  top: 0;
  left: 0;
}

.story-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  z-index: 1060;
  background: #000;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);
}

.story-media {
  width: 100%;
  height: auto;
  max-height: 90vh;
  display: block;
  object-fit: contain;
}

.premium-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.918); /* Dark overlay */
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 2rem;
    pointer-events: none;
  
}

.lock-icon {
    text-shadow: 0 0 5px rgba(0,0,0,0.6);
}

.logout-splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  font-family: 'Raleway';
  font-style: normal;
  background-color: #0A070F; /* green success */
  color: white;
  padding: 15px;
  text-align: center;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
  transition: top 0.3s ease-in-out;
}
.btn-primary{
  background: #D33E74;
  border: solid 0px;
}
.btn-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background: #D33E74;
    border-radius: 82px;
    margin-top: 8px;
    color: #fff;
    margin-left: 10px;
    
}
.modal-maskp {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;
        
        & > div {
            width: 80%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            //padding: 2em;
            border: 0.5px solid #D33E74;
            background: #19181B;
            border-radius: 20px;
            box-sizing: border-box;
        }
    .player-title{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 24px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
    }
    .amount {
        display: flex;
        flex-direction: row;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 19px;
        color: #FFFFFF;
        justify-content: space-between;
        .fees {
            
        }
        .price {
        
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 27px;
            color: #D33E74;
        }
    }
    .payment-option{
        display: flex; 
        flex-direction: row; 
    }
    .payment-types {
        width: 388px;
        height: 254px;
        background: #272528;
        border-radius: 8px;
        cursor: pointer;
        margin-bottom:20px;
        font-family: 'Nunito';
        font-style: normal;
        .payhow{
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 700;
            font-size: 12px;
            line-height: 10px;
            letter-spacing: -0.02em;
            color: #FFFFFF;
            text-align: center;
            margin-top: 10px;
        }
        .payment{
            margin:15px;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 0px 14px;
            width: 314px;
            height: 46px;
            background: #19181B;
            border-radius: 4px;
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 22px;
            letter-spacing: -0.02em;
            color: #FFFFFF;
        }

        h3{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 42px;
            text-align: center;
            color: #0A070F;
        }
        
        
    }
    .player-payinfo{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        text-align: center;
        color: #FFFFFF;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    .player-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px;
        height: auto;
        width: 40px;
        background: #333;
        border-radius: 5px;
        font-family: 'Source Sans 3';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        color: #FFFFFF;
        margin-top: 10px;
        margin-bottom: 30px;
        //display: block;
        margin-left: auto;
        margin-right: auto;
    }   
    }

    .modal-maskyx {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;

        & > div {
            width: 80%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            //padding: 2em;
            border: 0.5px solid #D33E74;
            background: #19181B;
            border-radius: 20px;
            box-sizing: border-box;
        }
    .player-title{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 24px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
    }
    .game-mode{
        display: flex; 
        flex-direction: column; 
    }
    .live-mode {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
        padding: 10px;
        width: 100%;
        height:50px;
        margin:4px;
        border: 1px solid #D33E74;
        border-radius: 4px;
        margin-right: 20px;
        cursor: pointer;

        h3{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 42px;
            text-align: center;
            color: #FFF;
        }
        p{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 13px;
            line-height: 1px;
            text-align: center;
            color: #FFF;
            margin-top: -10px;
        }
        
    }
    .live-mode:hover {
        background: #D33E74;

        P{
            color: #19181B;
        }
        h3{
            color: #19181B;
        }
    }
    .party-mode {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px;
        width: 220px;
        height: 180px;
        background: #19181B;
        border: 1px solid #D33E74;
        border-radius: 27px;
        cursor: pointer;

        h3{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 42px;
            text-align: center;
            color: #FFFFFF;
        }
        p{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 10px;
            line-height: 12px;
            text-align: center;
            color: #FFFFFF;
            margin-top: -10px;
        }
    }
    .player-name{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 31px;
        text-align: center;
        color: #FFFFFF;

    }
    .player-payinfo{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
        padding: 4px;
        width: 110%;
        height: 30px;
        background: rgba(211, 62, 116, 0.1);
        border-radius: 5px;
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        text-align: center;
        color: #D33E74;
        margin-top: 20px;
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-bottom:20px


    }
    .player-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px;
        height: auto;
        background: #111112;
        border-radius: 5px;
        font-family: 'Source Sans 3';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 28px;
        color: #FFFFFF;
        margin-top: 10px;
        margin-bottom: 30px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }   
    }
  .modal-xl {
      width: 90%;
     max-width:1200px;
  }
 .modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 350px;
      height: 250px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      //padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      background: #19181B;
      border-radius: 20px;
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
    h2 {
        margin-top: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    label {
        text-align: left;
        color: #fff;
        font-size: 12px;
        margin-left:15px;
        margin-bottom: -6px;
    }
    span {
        margin-bottom: 20px;
    }

  }
  .login-modal-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin-top: 10px;
    margin-left: 10px;
    background: #19181B;
    border: 0.5px solid #767475;
    border-radius: 50px;
    //width:500%;
  }
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  
.modal-masky {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .4s ease;
    & > div {
        //width: 100%;
        height: 200px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        //padding: 2em;
        border: 1px solid #2F2F2F;
        //backdrop-filter: blur(13px);
        background: #19181B;
        border-radius: 20px;
        box-sizing: border-box;
      }
      .profile-view2{
        box-sizing: border-box;
        border-radius: 20px;
        //position:relative;
        width: 100%;
        height: 100%;
       // background: #111112;

        .profile-photo2{
            width: 100%;
            height: auto;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        }
    }
    .profile-info2 {
    padding: 1rem 2rem 2rem 1rem;

        h3{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 16px;
            line-height: 24px;
            text-align: left;
            color: #FFFFFF;
            margin-left: 20px;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 10px;
            text-align: left;
            color: #767475;
            margin-left: 20px;
        }
    }
    .profile-bio2{
        
        P {
            width: auto;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 154.2%;
            color: #767475;;
            text-align: left;
            margin:20px;
        }

    }
    .profile-interest2{
        
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .interests2{
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 2px 8px;
            width: auto;
            height: 29px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 50px;
            color: #767475;
            font-size: 10px;
            margin: 4px;

        }
        .interests-info2 {
            display: flex;
            flex-direction: row;
            //padding: 0rem 3rem 5rem 1rem;
        }
    }
    .profile-relationship-goal2{
        margin-top: -150px !important;
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .relationship-goal2 {
            display: flex;
            flex-direction: row;
            padding: 2px;
            width: 70%;
            height: auto;
            background: rgba(255, 214, 0, 0.1);
            border-radius: 61px;
            color: #FFD600;
            font-size: 10px;
            margin: 20px;
            text-align: left;
        }

    }
    .btn-unmatch-report2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        .btn-unmatch2 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #D33E74;
            margin: 20px;
            cursor: pointer;
        }
        .btn-unmatch3 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #b1acae;
            margin: 20px;
            cursor: pointer;
        }
        .btn-report2 {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #2D2D2D;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #767475;
            margin-right: 10px;
            cursor: pointer;
        }
    }
}

.bio-container{
  display: flex;
  flex-direction: row;
  justify-content: left;
}
.tab-content{
    background: #111112 !important;
}
.profile-preference{
  font-size: 13px;
  font-weight: bold;
  font-family: 'Raleway';
  font-style: normal;
  border: solid 1px #D33E74;
  border-radius: 4px;
  margin: 2px;
  text-align: center;
 h6{
  background: #D33E74;
  color: #fff;
  font-weight: bold;
 }
  small{
    font-size: 15px;
    text-transform: capitalize;
    color: #fff;
    text-align: center;
    font-weight: bold;
  }
}
.rate-display-section {
  padding: 4px;
  background: #111112;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0,0,0,0.05);
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
}

.rate-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 15px;
}

.image-wrapper{
  position: relative; 
  border-radius: 0px; 
  overflow: hidden;
  padding: 0;
}
.image-wrapper:hover{
  border: 1px solid#fff;
}
@media screen and (max-width: 768px) {
  .image-wrapper{
    border-radius: 0px; 
    padding: 0;
  }
}
.video-wrapper{
  position: relative; 
  border-radius: 10px; 
  overflow: hidden;
  border: 1px solid #D33E74;
  padding: 0.2rem;
}
.video-wrapper:hover{
  border: 1px solid#fff;
}
.rate-card {
  background-color: #fff;
  border: 0px solid #D33E74;
  padding: 5px;
  border-radius: 10px;
  text-align: left;
  transition: 0.3s ease;
}

.rate-card:hover {
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.rate-duration {
  font-size: 22px;
  font-weight: 600;
  color: #D33E74;;
  margin-bottom: 8px;
}

.rate-price {
  font-size: 20px;
  color: #666;
  margin-bottom: 4px;
}

.no-rates {
  text-align: center;
  color: #999;
}

.preferences-list {
  width: 100%;
  padding: 4px;
  background: #111112;
  border-radius: 12px;
  font-family: 'Raleway';
  font-style: normal;
}

.preference-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  strong{
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    background: #0A070F;
    padding: 0.3rem;
    border-radius: 5px;
  }
  span{
    color: #D33E74;
    font-size: 15px;
    font-weight: bold;
  }
}

.preference-item-p {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  color: #D33E74;
    font-size: 15px;
    font-weight: bold;
 

  strong{
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    background: #0A070F;
    padding: 0.3rem;
    border-radius: 5px;
  }
  span{
    color: #D33E74;
    font-size: 15px;
    font-weight: bold;
  }
}

h2 {
  text-align: left;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 700;
}

.loading {
  text-align: center;
  font-weight: bold;
}

.no-data {
  text-align: center;
  color: #888;
}

.disabled-chat {
  pointer-events: none;
  background-color: #ccc;
  color: #888;
  border-radius: 5px;
  padding: 8px 12px;
  display: inline-block;
}

.nav-link{
    color: #fff;
    padding: 0.2rem;
}
.nav-tabs{
  border-bottom: 0px solid #111112;
  gap: 10px;
}
 .nav-tabs .nav-link {
    cursor: pointer;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 13px;
    padding: 7px;
    background-color: #2D2D2D;
 }
 .nav-tabs .nav-link:hover {
  color: white;
 }

.nav-tabs .nav-link.active {
    background-color: #D33E74;
    color: white;
    border-radius: 0.25rem;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 12px;
}
.nav-item{
  font-family: 'Raleway';
  font-style: normal;
  font-size: 12px;
}
.back a{
    text-decoration: none;
    color: #D33E74;
}
.mobile-line{
    display: flex;
    color: #767475;
    width: 90%;
}
.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
    margin-top:-300px
  }
  .img-fluid{
    border-radius: 0px;
    width: 100%;
    aspect-ratio: 4 / 5;
    object-fit: cover;
    transition: transform 0.3s ease-in-out; /* Optional for smooth effect */
  }
  .video-fluid{
    border-radius: 0px;
    width: 100%;
    aspect-ratio: 4 / 5;
    object-fit: cover;
    transition: transform 0.3s ease-in-out; /* Optional for smooth effect */
  }
  .image-padding{
      padding: 0;
  }
  .profile-count-container{
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
  }
  .profile-count1{
    position: relative;
    color: white;
  }
  .profile-count{
    display: inline-block;
    background: #D33E74;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
  }
  .profile-metrics{
    display: flex;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    width: 100%;
    margin-top: 0px;
  }
  .metric-card{
    display: flex;
    flex-direction:row;
    justify-content: center;
    min-height: 10px;
    padding: 0px 7px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
    backdrop-filter: blur(10px);
  }
  .metric-card--views{
    text-align: center;
    background: linear-gradient(180deg, rgba(59, 130, 246, 0.16), rgba(59, 130, 246, 0.06));
    border-color: rgba(59, 130, 246, 0.24);
  }
  .metric-card--earn{
    text-align: center;
    background: linear-gradient(180deg, rgba(211, 62, 116, 0.18), rgba(211, 62, 116, 0.08));
    border-color: rgba(211, 62, 116, 0.28);
  }
  .metric-label{
    color: rgba(255, 255, 255, 0.72);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin-bottom: 4px;
  }
  .metric-value{
    color: #ffffff;
    font-size: 10px;
    font-weight: 800;
  
  }
  .metric-caption{
    margin-top: 4px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 10px;

  }
  .view-count{
   // display: flex;
  }
  @media screen and (max-width: 768px) {
    .profile-metrics{
      margin-top: 0px;
      max-width: 100%;
      grid-template-columns: 1fr;
    }

    .fullmobile-size{
      height: 750px;
    }
    .img-fluid{
      border-radius: 0px;
      padding: 0;
      width: 100%;
      aspect-ratio: 4 / 5;
      object-fit: cover;
      transition: transform 0.3s ease-in-out; /* Optional for smooth effect */
    }

    .image-padding{
      padding: 0;
    }
  }
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }
  .verified-icon {
        margin-left: 5px;
        font-size: 16px;
        vertical-align: middle;
    }
    .text-success{
        color: #25D366 !important;
    }
  .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }
.modal-mask {
    // position: fixed;
     z-index: 9998;
     top: 0;
     left: 0;
     //width: 100%;
     height: 100%;
     background: rgba(0, 0, 0, .5) !important;
     display: table;
     transition: opacity .3s ease;
     & > div {
         //width: 100%;
         height: 120px;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
         //padding: 2em;
         border: 1px solid #2F2F2F;
         //backdrop-filter: blur(13px);
         background: #19181B;
         border-radius: 20px;
         box-sizing: border-box;
       }
       .profile-view2{
         box-sizing: border-box;
         border-radius: 20px;
         //position:relative;
         width: 100%;
         height: 100%;
         background: #111112;
         .profile-photo2{
             width: 100%;
             height: auto;
             background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
         }
     }
   }
.container {
    width: 100%;
    min-height: 80vh;
}


.profile-container{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.large-profile-pic {
  width: 140px;
  height: 140px;
  border-radius: 50%;
}

 .profile-image {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    .img-profile {
        width: 60%;
        height: 60%;
        margin:2px;
        border-radius: 100px;
    }


    .profile-info {
         padding: 0 0 0 20px;
         margin-top:60px;

        h3 {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 1px;
            text-align: left;
            color: #FFFFFF;
            margin-top: 10px;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            line-height: 10px;
            text-align: left;
            color: #FFFFFF;
        }        
        .likes-followers{

            h4{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 450;
                font-size: 12px;
                color: #FFFFFF;
                text-align: center !important;
            }
        }
    }
    .btn-book{
      color: #FFFFFF;
      background-color: #df3a6a;
      font-size: 14px;
      font-weight: bold;
      border-radius: 10px;
      padding: 0.3rem;
    }
    .profile-header-info{
      display: none;
    }
    .select-profile{
        text-align: center !important;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
        border: 3px solid #D33E74;
        border-radius: 50%;
        width: 145px;
        height: 145px;
        display: block;
        margin-top: 15px;
        margin-bottom: 25px;
        z-index: 999;
    }
 }
.profile-edit-button{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        //margin-top: 150px;
        //width: 100%;

    .action-buttons {
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        gap: 8px;
        width: 100%;
       // overflow-x: auto;
    }

    .btn-follow {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px 4px;
        width: 80px;
        height: 30px;
        background: #D33E74;
        border: 0.5px solid #D33E74;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
        white-space: nowrap;
    }
     @media screen and (max-width: 768px) {
         .btn-follow {
            padding: 3px 2px;
            width: 60px;
            height: 25px;
            font-size: 10px;
        }
     }

    .btn-follow.disabled,
    .btn-tip.disabled,
    .btn-book.disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    .btn-tip{
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px 4px;
        width: 80px;
        height: 30px;
        background: #FF8A00;
        border: 0px solid #FF8A00;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
        cursor: pointer;
        transition: background 0.3s;
        white-space: nowrap;
        
        &:hover {
            background: #E67E00;
        }
    }

     @media screen and (max-width: 768px) {
        .btn-tip {
            padding: 3px 2px;
            width: 70px;
            height: 25px;
            font-size: 10px;
        }
     }
    .btn-chat {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px 4px;
        width: 70px;
        height: 30px;
        background: #007BFF;
        border: 0px solid;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
}

.btn-ellipsis {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #D33E74;
  font-size: 1.3rem;
  border-radius: 50%;
  transition: all 0.2s;
}

.btn-ellipsis:hover {
  background: rgba(0, 0, 0, 0.08);
  color: #333;
}

.dropdown-item {
  padding: 10px 16px;
  font-size: 0.95rem;
}

.dropdown-item i {
  width: 18px;
}

.dropdown-item.disabled,
.dropdown-item:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.photo {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    color: #FFFFFF;
    margin-left: -45px;
    margin-top: 10px;

}

 .edit-profile-top {
  //padding: 0rem 1rem 2rem 0rem;
  margin-left: 20px;
 }
 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;
        //background: #D9D9D9;
    }
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-textx {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #767475 !important;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    //color: #767475;
 }
 .birthday{
    display: flex;
    flex-direction: row;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 114px;
    height: 55px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    //margin: 2px;
    color: #767475;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 400px;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
    margin-bottom: 40px;
}

.btn-chips {
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    padding: 4px 10px;
    width: auto;
    height: 25px;
    margin: 3px;
    margin-bottom: 20px;
    background: #0A070F;
    border: 0.5px solid #D33E74;
    border-radius: 50px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: #D33E74;
}      

@media screen and (max-width: 700px) {

  .modal-maskp {
            position: fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display: table;
            transition: opacity .4s ease;
            
            & > div {
                width: 80%;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                //padding: 2em;
                border: 0.5px solid #D33E74;
                background: #19181B;
                border-radius: 20px;
                box-sizing: border-box;
            }
        .player-title{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 24px;
            line-height: 42px;
            text-align: center;
            color: #FFFFFF;
        }
        .amount {
            display: flex;
            flex-direction: row;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 13px;
            line-height: 19px;
            color: #FFFFFF;
            justify-content: space-between;
            .fees {
                
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 700;
                font-size: 12px;
            }
            .price {
                
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 700;
                font-size: 12px;
                line-height: 27px;
                color: #D33E74;
            }
        }
        .payment-option{
            display: flex; 
            flex-direction: row; 
        }
        .payment-types {
            width: 100%;
            height: 254px;
            background: #272528;
            border-radius: 8px;
            cursor: pointer;
            .payhow{
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 700;
                font-size: 12px;
                line-height: 10px;
                letter-spacing: -0.02em;
                color: #FFFFFF;
                text-align: center;
                margin-top: 10px;
            }
            .payment{
                margin:15px;
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 0px 14px;
                width: 90%;
                height: 46px;
                background: #19181B;
                border-radius: 4px;
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 600;
                font-size: 11px;
                line-height: 22px;
                letter-spacing: -0.02em;
                color: #FFFFFF;
            }
    
            h3{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 42px;
                text-align: center;
                color: #0A070F;
            }
            
            
        }
        .player-payinfo{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 11px;
            line-height: 14px;
            text-align: center;
            color: #FFFFFF;
            display: block;
            margin-left: auto;
            margin-right: auto;
        }
       
        }

  .bio-container{
    margin-bottom: auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
    .gallery-header{
      //padding: 10px 0 0 25px;
    }
    .col-sm-12{
      padding: 0 0px 0 0px !important;
    }
    .container{
        padding: 0px 0px 0px 0px !important;
    }

   
    .back{
        margin-top: 45px;
    }
    .profile-container{
      display: flex;
      flex-direction: row;
      justify-content: left;
      margin: 0;
     
      @media screen and (max-width: 700px) {

         .btn-book1{
          background-color: #df3a6a;
          color: #fff;
          border: none;
          padding: .2rem 1rem;
          border-radius: 200px;
          width: 90px;
          height: 40px;
          display: grid;
          place-items: center;
          font-size: 14px;
          line-height: 22px;
          cursor: pointer;
         }
       }

    }
    .bio-tab{
        //background: #111112;
    }
    .bio-text{display: none;}
    .bio-content-text{
      text-align: center;
    }
    .nav-link{
      color: #fff;
    }
    .nav-tabs .nav-link {
      cursor: pointer;
      font-size: 12px;
    }

    .nav-tabs .nav-link.active {
        background-color: #D33E74;
        color: white;
        border-radius: 0.25rem;
    }

    .mobile-line{
        display: flex;
        color: #767475;
        width: 100%;
        display: none;
    }
    .profile-image {
        display: flex;
        flex-direction: column;
        width: 50%;

       

        .img-profile {
            width: 30%;
            height: 30%;
        }
        .profile-info {
            display: none;
            flex-direction: column;
            //padding: 0px 0 0 0px;
            margin-top:10px;
            
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bolder;
                font-size: 12px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 12px;
                line-height: 20px;
                text-align: right;
                color: #FFFFFF;
                width: 350px;
            }
            .likes-followers{
                margin-top: 10px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
        }
          
        }
        .profile-header-info{
          display: block;
          width: 500px !important;
            .d-flex h3{
              font-size: 1.2rem;
            }
           .profile-meta {
            font-size: 0.95rem;
            line-height: 1.4;
          }

          @media (max-width: 576px) {
            .profile-meta {
              font-size: 0.9rem;
            }
          }
          
        }
       
        .select-profile{
            width: 145px;
            height: 145px;
        }
     }
    .profile-edit-button{
      display: flex;
      flex-direction: row;
      justify-content: right;
      margin-top: 80px;
      width: 100%;

      .action-buttons {
        display: flex;
        flex-wrap: nowrap;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;
        width: 100%;
        margin-bottom: 40px;
      }
      
        .btn-follow.disabled,
        .btn-tip.disabled,
        .btn-book.disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }
    .photo {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 28px;
        text-align: left;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 50px;
    }
 .edit-profile-top {
  padding: 0rem 1rem 2rem 0rem;
  margin-left: 20px;
 }
 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    margin-left: 10px;

    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;
        margin-left: 30%;
    }
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 35px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
 }
 .birthday{
    display: flex;
    flex-direction: column;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 100%;
    height: 45px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    //margin: 2px;
    color: #767475;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
   
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
}

}

</style>

